import React, { Component, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import "tippy.js/dist/tippy.css";
import _, { cloneDeep } from "lodash";
import Moment from "moment";
import MicroModal from "micromodal";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import { endOfDay, isWithinInterval, parse, startOfDay } from "date-fns";
import {
  Messages,
  MessageNotif,
  DirectboxReceive,
  CloseCircle,
} from "iconsax-reactjs";

//ACTIONS
import {
  refreshUsersAgents,
  ShowVisibleNextAtd,
  GetHistory,
  returnListCallQueue,
  DetailsAnotationsida,
  DetailsFileShared as DetailsFileSharedIn,
  CarregamentoCDR,
  DownloadFile,
  DetailsMarkstarida,
  SearchingHistoryData,
  RequestActiveCall,
  CarregamentoInteractions,
  SolicitarChamada as SolicitarChamadaIn,
  InterationNotifier,
  RequestActiveCallSocketVoz,
  ActionRefreshNoAnswer,
  callbackChange,
  filaChange,
  tratamentoChange,
  arrayChange,
  retornoChange,
  ShowInfoDisplay,
  InteracoesContactNumber,
  GetInteractionsModal,
  editInitialDateFilterQuarentine,
  editFinalDateFilterQuarentine,
  changeNextCallQueueTab,
  changeWaitingCallQueueTab,
  changeChatCallQueueTab,
  sendQueueAndStandby,
  AdicionarValoresIniciaisDoFiltroDeFila,
  updateUserFilters,
  SolicitarChamadaAtiva as SolicitarChamadaAtivaToAutoCallback,
} from "../../actions";
import { RefreshNoAnswerCall } from "../../actions/websocket";
import { Tooltippy } from "../../actions/Tippy";

//COMPONENTS
import DeleteCallModal from "../../modals/DeleteCallModal";
import TransferClientModal from "../TransferClientModal";
import Drawer from "../../components/manager-section/Drawer/Drawer";
import ModalsDetails from "../../components/modals/NewModals/index";
import QueueItem from "../../components/queue-section-new/QueueItemNew";
import PdfDocument from "../../components/templates/PdfDocument";
import FieldContainer from "../../components/FieldContainer/FieldContainer";
import DatePicker from "../../components/DatePicker";
import QueueTab from "../../components/QueueTab";
import QuarentineZoneContent from "../../components/QuarentineZoneContent";
import Typography from "../../components/Typography";
import ChatsContent from "../../components/ChatsContent";

//ASSETS
import { ReactComponent as FilterIcon } from "../../build/images/filter.svg";
import { ReactComponent as Arrow } from "../../build/images/arrow-left.svg";
import { ReactComponent as Search } from "../../build/images/teams/search-normal.svg";
import { ReactComponent as FilterIconNew } from "../../build/images/teams/search-normal-new.svg";
import { ReactComponent as Anotacoes } from "../../build/images/popover-queue/edit-2.svg";
import { ReactComponent as ArquivosComp } from "../../build/images/popover-queue/direct-send.svg";
import { ReactComponent as MsgFavoritas } from "../../build/images/popover-queue/sms-star.svg";
import { ReactComponent as Mapa } from "../../build/images/popover-queue/picture-frame.svg";
import { ReactComponent as Interacoes } from "../../build/images/popover-queue/people.svg";
import { ReactComponent as AlterarExcluir } from "../../build/images/popover-queue/call-slash.svg";
import { ReactComponent as Transferir } from "../../build/images/popover-queue/redo.svg";
import { ReactComponent as IconMaximize } from "../../build/images/popover-queue/maximize-icon.svg";

//CSS
import "react-image-lightbox/style.css";
import "./queue-new-v2.css";
import { STATUS_ID_MAPPING } from "../../utils/statusIdMapping";
import { autoAsnwerCallbackServiceSingleton } from "../../utils/autoAsnwerCallbackService";
import {
  changeAgentStatusToRV,
  verifyIfCallIsStillInQueue,
  verifyIfStatusStillLV,
} from "../../thunks/IngDeskIntegration/verifyIfCallIsStillInQueue";

const { connection_platform } = require("../../services/api");
const { filtro_fila } = require("../../services/data");

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
var statusIntervalCBack = "";
var checkCallBack = false;
var checkStatusAgente = "";

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
}

let statusArray = [
  {
    id: "0",
    title: "CallBack",
  },
  {
    id: "1",
    title: "Em fila de espera",
  },
  {
    id: "2",
    title: "Em Tratamento",
  },
  {
    id: "5",
    title: "Retornando",
  },
];

MicroModal.init();

export default function QueueNewV2({ exhibDrawer, typeScreen = "" }) {
  //GENERAL
  let dispatch = useDispatch();
  let initialDateLater = new Date();
  initialDateLater.setDate(new Date().getDate() - 7);
  let storageMedia = localStorage.getItem("clients_queue_media") || [];
  if (storageMedia.length !== 0) {
    storageMedia = storageMedia.split(",").map(Number);
  }
  let storageStatus = localStorage.getItem("clients_queue_status") || [];
  if (storageStatus.length !== 0) {
    storageStatus = storageStatus.split(",");
  }
  let storageSubservice =
    localStorage.getItem("clients_queue_subservice") || [];
  if (storageSubservice.length !== 0) {
    storageSubservice = storageSubservice.split(",").map(Number);
  }
  // let filtermediastorage = storageMedia;
  // let filterstatusstorage = storageStatus;
  // let filtersubservicestorage = storageSubservice;
  let timedefaultinitqueue = Moment().format("YYYY-MM-DDT00:00");
  let timedefaultfimqueue = Moment().format("YYYY-MM-DDT23:59");
  let datatimeinitqueue = Moment().format("YYYY-MM-DD");
  let datatimefimqueue = Moment().format("YYYY-MM-DD");
  let timearqinitqueue = Moment().format("YYYY-MM-DD");
  let timearqfimqueue = Moment().format("YYYY-MM-DD");
  let datainitqueue = Moment().format("YYYY-MM-DD");
  let datafimqueue = Moment().format("YYYY-MM-DD");

  //SELECTORS
  const filtrosDeFila = useSelector((state) => state.filtrosDeFila);
  const listCallQueue = useSelector((state) => state.listcallqueue);
  const InfoUsers = useSelector((state) => state.informationusers);
  const PermissionRouter = useSelector((state) => state.routergroups);
  const StatusAgent = useSelector((state) => state.status);
  const OutBandService = useSelector((state) => state.outservices);
  const DisplayNextAtd = useSelector((state) => state.displaynextatd);
  const DetailsAnotations = useSelector((state) => state.detailsanotations);
  const CriticidadesAnotacoes = useSelector((state) => state.criticalitys);
  const IPCurrent = useSelector((state) => state.ipcurrent);
  const DetailsMarkstar = useSelector((state) => state.detailsmarkstars);
  const DetailsFileShared = useSelector((state) => state.detailsfileshared);
  const History = useSelector((state) => state.history);
  const CallBack = useSelector((state) => state.callback);
  const AtdSimult = useSelector((state) => state.atdsimult);
  const Filters = useSelector((state) => state.filters);
  const InfoDisplay = useSelector((state) => state.infodisplay);
  const callpark = useSelector((state) => state.callpark);
  const ListQueuePermission = useSelector((state) => state.queuepermission);
  const listQuarentineQueue = useSelector(
    (state) => state.listQuarentineQueue.list,
  );
  const defaultInitialDateQuarentine = useSelector(
    (state) => state.dateOfFilterQuarentine.initial,
  );
  const defaultFinalDateQuarentine = useSelector(
    (state) => state.dateOfFilterQuarentine.final,
  );
  const queueTabActiveNextCall = useSelector(
    (state) => state.queueTabActive.isTabNextCallInfoActive,
  );
  const queueTabActiveWaiting = useSelector(
    (state) => state.queueTabActive.isTabWaitingInfoActive,
  );
  const queueTabActiveChat = useSelector(
    (state) => state.queueTabActive.isTabChatInfoActive,
  );
  const ContactId = useSelector((state) => state.atendimento);

  let filtermediastorage = filtrosDeFila.storageMedia;
  let filterstatusstorage = filtrosDeFila.storageStatus;
  let filtersubservicestorage = filtrosDeFila.storageSubservice;

  //STATES
  const [filterMediaStorage, setFilterMediaStorage] = useState(
    filtrosDeFila.storageMedia,
  );
  const [filterStatusStorage, setFilterStatusStorage] = useState(
    filtrosDeFila.storageStatus,
  );
  const [filterSubserviceStorage, setFilterSubserviceStorage] = useState(
    filtrosDeFila.storageSubservice,
  );
  const [buttonFilterQueue, setButtonFilterQueue] = useState(false);
  const [buttonDetails, setButtonDetails] = useState(false);
  const [buttonDetailsIn, setButtonDetailsIn] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [history, setHistory] = useState([]);
  const [filterQueue, setFilterQueue] = useState([]);
  const [filterQuarentineQueue, setFilterQuarentineQueue] = useState("");
  const [keyQueue, setKeyQueue] = useState([]);
  const [visible, setVisible] = useState("");
  const [auxkeyQueue, setAuxKeyQueue] = useState([]);
  const [typequeue, setTypeQueue] = useState(filtro_fila);
  const [callqueue, setCallQueue] = useState([]);
  const [typesubservice, setTypeSubservice] = useState(
    filtrosDeFila.storageSubservice,
  );
  const [typemedia, setTypeMedia] = useState(filtrosDeFila.storageMedia);
  const [typestatus, setTypeStatus] = useState(filtrosDeFila.storageStatus);
  const [expandQueue, setExpandQueue] = useState([]);
  const [DescAnotacoes, setDescAnotacoes] = useState([]);
  const [critSelec, setCritSelec] = useState("Todos");
  const [iconCrit, setIconCrit] = useState("");
  const [idCrit, setIdCrit] = useState("");
  const [idCrit2, setIdCrit2] = useState("");
  const [buttonShowCriticits, setButtonShowCriticits] = useState(false);
  const [detailsAnotations, setDetailsAnotations] = useState([]);
  const [detailsMarkstar, setDetailsMarkstar] = useState([]);
  const [detailsFileShared, setDetailsFileShared] = useState([]);
  const [totalAnotations, setTotalAnotations] = useState(0);
  const [totalMarkstar, setTotalMarkstar] = useState(0);
  const [totalFiles, setTotalFiles] = useState(0);
  const [buttonLearnMore, setButtonLearnMore] = useState(false);
  const [expandLearn, setExpandLearn] = useState([]);
  const [optionsActionsFile, setOptionsActionsFile] = useState([]);
  const [buttonShowOptionsAnot, setButtonShowOptionsAnot] = useState(false);
  const [buttonShowInsertAnot, setButtonShowInsertAnot] = useState(false);
  const [SelecCritic, setSelecCritic] = useState("Selecione");
  const [defaultValueFormat, setDefaultValueFormat] = useState("Todos");
  const [defaultValueMidias, setDefaultValueMidias] = useState("Todos");
  const [totalhistory, setTotalHistory] = useState(0);
  const [nameCli, setNameCli] = useState("Cliente");
  const [scrollEnd, setScrollEnd] = useState(30);
  const [isOpen, setIsOpen] = useState(false);
  const [cliente, setCliente] = useState("");
  const [midias, setMidias] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isViewStatus, setIsViewStatus] = useState(false);
  const [isViewSubservices, setIsViewSubservices] = useState(false);
  const [isViewChannels, setIsViewChannels] = useState(false);
  const [initialDate, setInitialDate] = useState(initialDateLater);
  const [finalDate, setFinalDate] = useState(new Date());
  const [initialDateAfter, setInitialDateAfter] = useState(initialDateLater);
  const [finalDateAfter, setFinalDateAfter] = useState(new Date());
  const [subservicesList, setSubservicesList] = useState([]);
  const [textSearchSubservice, setTextSearchSubservice] = useState("");
  const [textMediaCheck, setTextMediaCheck] = useState("Marcar todos");
  const [textStatusCheck, setTextStatusCheck] = useState("Marcar todos");
  const [textSubserviceCheck, setTextSubserviceCheck] =
    useState("Marcar todos");
  const [tabChatsInfo, setTabChatsInfo] = useState({
    id: "chats",
    title: "Conversas",
    qtdMessages: 0,
    isActive: queueTabActiveChat,
    icon: <Messages variant="Outline" />,
  });
  const [tabNextCallInfo, setTabNextCallInfo] = useState({
    id: "nextCall",
    title: "Próximos atendimentos",
    qtdMessages: 0,
    isActive: queueTabActiveNextCall,
    icon: <MessageNotif variant="Outline" />,
  });
  const [tabWaitingInfo, setTabWaitingInfo] = useState({
    id: "waiting",
    title: "Stand by",
    qtdMessages: 0,
    isActive: queueTabActiveWaiting,
    icon: <DirectboxReceive variant="Outline" />,
  });
  const [qtdOfClientsInTheQueue, setQtdOfClientsInTheQueue] = useState(0);
  const [filteredListQuarentineQueue, setFilteredListQuarentineQueue] =
    useState(listQuarentineQueue);
  const [qtdOfClientsInQuarentineZone, setQtdOfClientsInQuarentineZone] =
    useState(0);
  const [
    qtdOfUnreadedMessagesInQuarentineZone,
    setQtdOfUnreadedMessagesInQuarentineZone,
  ] = useState(0);
  const [qtdOfChatsInTheQueue, setQtdOfChatsInTheQueue] = useState(0);
  const [filtermediastorageQuarentine, setFilterMediaStorageQuarentine] =
    useState(() => {
      const data = localStorage.getItem("clients_queue-quarentine_media");
      return data ? JSON.parse(data) : [];
    });
  const [textMediaCheckQuarentine, setTextMediaCheckQuarentine] =
    useState("Marcar todos");
  const [initialDateQuarentine, setInitialDateQuarentine] = useState(
    defaultInitialDateQuarentine,
  );
  const [finalDateQuarentine, setFinalDateQuarentine] = useState(
    defaultFinalDateQuarentine,
  );
  const [expandInfos, setExpandInfos] = useState({
    RetractExpand: "Expandir todos",
    expandcollapse: "expand",
    unfold: "unfold_more",
  });
  //   const [RetractExpand, setRetractExpand] = useState("Expandir todos");
  //   const [expandcollapse, setExpandCollapse] = useState("expand");
  //   const [unfold, setUnfold] = useState("unfold_more");
  const [queueid, setQueueId] = useState(-1);
  const [filter, setFilter] = useState("");
  const [arrowterm, setArrowterm] = useState(0);
  const [datapdfend, setDatapdfend] = useState("");
  const [datapdfinit, setDatapdfinit] = useState("");
  const [senhaincorreta, setSenhaIncorreta] = useState("");
  const [numberqueue, setNumberqueue] = useState("");
  const [modalOpen, setModalOpen] = useState("");
  const [queueModalOpen, setQueueModalOpen] = useState(0);
  const [deletequeueid, setDeletequeueid] = useState("");
  const [deletecdrid, setDeletecdrid] = useState(0);
  const [mediaid, setMediaid] = useState(0);
  const [cdrid, setCdrid] = useState(0);
  const [scriptid, setScriptid] = useState(0);
  const [showHistory, setShowHistory] = useState(false);
  const [buttonShowFormatsFile, setButtonShowFormatsFile] = useState(false);
  const [buttonShowMidias, setButtonShowMidias] = useState(false);
  const [urlimage, setUrlImage] = useState("");
  const [iconeCriticidade, setIconeCriticidade] = useState("");
  const [msgsTotalChats, setMsgsTotalChats] = useState(0);
  const [statusQueue, setStatusQueue] = useState(statusArray);

  const isToBlockEdition = filtrosDeFila.isToBlockEdition;

  var voz = false;

  if (InfoUsers.user_midias) {
    for (var i = 0; i < InfoUsers.user_midias.length; i++) {
      if (InfoUsers.user_midias[i] === 1) voz = true;
    }
  }
  const isRegistrandoCip = Boolean(!InfoUsers.enablecallvoz && voz);
  //FUNCTIONS
  function checkCallBackAuto(queueid, time, qtdemax, statusagente, queue) {
    autoAsnwerCallbackServiceSingleton.addCallInList(queueid);
    checkStatusAgente = statusagente;
    console.log("INGENIUM checkCallBackAuto, requisitado");
    statusIntervalCBack = setTimeout(async () => {
      // let element = document.getElementById("clickqueue_" + queueid);
      // if (typeof element != "undefined" && element != null) {
      //   element.click();
      // }

      autoAsnwerCallbackServiceSingleton.removeCallOfList(queueid);

      const isTheCallStillInTheQueueAndOperatorStatusIsLV =
        dispatch(verifyIfCallIsStillInQueue(queueid)) &&
        dispatch(verifyIfStatusStillLV());

      if (isTheCallStillInTheQueueAndOperatorStatusIsLV) {
        console.log("INGENIUM checkCallBackAuto, chamada solicitada");
        await dispatch(changeAgentStatusToRV());

        dispatch(
          SolicitarChamadaAtivaToAutoCallback(
            parseInt(queue.mediaid),
            queue.caller,
          ),
        );
      }
      checkCallBack = false;
    }, time * 1000);
  }

  function getInfoQueue(queues, idqueue) {
    const queue = queues.find((queue) => queue.serviceinid === idqueue);
    return queue
      ? { id: queue.serviceinid, title: queue.name }
      : "Fila não encontrada";
  }

  function getInfoQueue2(queue) {
    return { id: queue.serviceinid, title: queue.name };
  }

  function parseData(dataString) {
    const [dia, mes, ano] = dataString.split("/");
    return new Date(ano, mes - 1, dia);
  }

  function createJSON(item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }

  function updateFilteredList() {
    let textToFilter = filterQuarentineQueue;

    let updatedFilteredListQuarentineQueue = listQuarentineQueue;
    const hasTextToFilter = !!textToFilter;
    if (hasTextToFilter) {
      updatedFilteredListQuarentineQueue = listQuarentineQueue.filter(
        (quarentineItem) => {
          return quarentineItem.contactName
            .toLowerCase()
            .includes(textToFilter.toLowerCase());
        },
      );
    }

    // const hasFiltermediastorageQuarentine =
    //   !!filtermediastorageQuarentine &&
    //   Array.isArray(filtermediastorageQuarentine) &&
    //   filtermediastorageQuarentine.length > 0;
    // if (hasFiltermediastorageQuarentine) {
    //   updatedFilteredListQuarentineQueue =
    //     updatedFilteredListQuarentineQueue.filter((quarentineItem) => {
    //       return filtermediastorageQuarentine.includes(
    //         parseInt(quarentineItem.midiaId)
    //       );
    //     });
    // }

    // const hasFinalAndInitialDate =
    //   !!initialDateQuarentine && !!finalDateQuarentine;
    // if (hasFinalAndInitialDate) {
    //   updatedFilteredListQuarentineQueue =
    //     updatedFilteredListQuarentineQueue.filter((quarentineItem) => {
    //       const hasDateTime = !!quarentineItem.dateTime;
    //       if (!hasDateTime) {
    //         return true;
    //       }
    //       const dateOfStandBy = parse(
    //         quarentineItem.dateTime,
    //         "dd/MM/yyyy HH:mm:ss",
    //         new Date()
    //       );
    //       return isWithinInterval(dateOfStandBy, {
    //         start: startOfDay(initialDateQuarentine),
    //         end: endOfDay(finalDateQuarentine),
    //       });
    //     });
    // }

    const updatedQtdOfUnreadedMessagesInQuarentineZone =
      updatedFilteredListQuarentineQueue.reduce((accumulator, currentValue) => {
        const unreadMessages = currentValue.unreadMessages
          ? currentValue.unreadMessages
          : 0;
        return accumulator + unreadMessages;
      }, 0);

    setFilteredListQuarentineQueue(updatedFilteredListQuarentineQueue);
    setQtdOfClientsInQuarentineZone(updatedFilteredListQuarentineQueue.length);
    setQtdOfUnreadedMessagesInQuarentineZone(
      updatedQtdOfUnreadedMessagesInQuarentineZone,
    );
  }

  function handleKeyUp(inf) {
    const elems = document.getElementsByTagName("mark");
    const tam = elems.length;

    if (tam >= arrowterm + 1) {
      elems[arrowterm].scrollIntoView(false);
      if (inf === "less") {
        if (arrowterm !== 0) {
          setArrowterm((prevState) => prevState - 1);
        }
      } else {
        setArrowterm((prevState) => prevState + 1);
      }
    } else {
      if (elems[arrowterm]) {
        setArrowterm(0);
        elems[arrowterm].scrollIntoView(false);
      }
    }
  }

  function SearchHistoryQueue(telefone) {
    let now = Moment().subtract(7, "days");
    const histstart = now.format("YYYY-MM-DD") + "T00:00";
    const histend = Moment().format("YYYY-MM-DD") + "T23:59";
    let idgroup = InfoUsers.idgroup;
    dispatch(SearchingHistoryData(histstart, histend, 33, telefone, idgroup));
    setDatapdfend(histend);
    setDatapdfinit(histstart);
    //   setDatapdfinit(histend)
  }

  function DisplayHistoric(telefone, cdrid) {
    let now = Moment().subtract(7, "days");
    const histstart = now.format("YYYY-MM-DD") + "T00:00";
    const histend = Moment().format("YYYY-MM-DD") + "T23:59";
    let idgroup = InfoUsers.idgroup;
    let telefoneFormat = telefone.length > 11 ? telefone.substr(2) : telefone;
    dispatch(
      InteracoesContactNumber(telefoneFormat, histstart, histend, "", idgroup),
    );
  }

  function DisplayFilterQueue(e) {
    // e.preventDefault();
    setButtonFilterQueue(!buttonFilterQueue);
  }

  function DisplayDetails(e) {
    e.preventDefault();
    setButtonDetails(!buttonDetails);
    let newState = buttonDetails
      ? {
          RetractExpand: "Expandir todos",
          expandcollapse: "expand",
          unfold: "unfold_more",
        }
      : {
          RetractExpand: "Retrair Todos",
          expandcollapse: "collapse",
          unfold: "unfold_less",
        };
    setExpandQueue((prevState) => (!buttonDetails ? [] : prevState));
    setExpandInfos({ ...expandInfos, ...newState });
  }

  function DisplayDetailsIn(event, idqueue) {
    event.preventDefault();
    setButtonDetailsIn(!buttonDetailsIn);
    setQueueId(idqueue);
  }

  function DisplayAnottations(event, idqueue) {
    event.preventDefault();
    setQueueId(idqueue);
  }

  function change(e) {}

  function get_filesize(url, callback) {
    let xhr = new XMLHttpRequest();
    xhr.open("HEAD", url, true);

    xhr.onreadystatechange = function () {
      if (this.readyState === this.DONE) {
        callback = callback(parseInt(xhr.getResponseHeader("Content-Length")));
      }
    };
    xhr.send();
  }

  function changeQueue(e) {
    const isQuarentineZone = tabWaitingInfo.isActive || tabChatsInfo.isActive;
    //se for a fila normal vai setar o valor de filterQueue
    if (!isQuarentineZone) {
      setFilterQueue(e.target.value);
      if (e.target.value !== "") {
        setKeyQueue([]);
      } else {
        setKeyQueue(auxkeyQueue);
      }
    } else {
      setFilterQuarentineQueue(e.target.value);
    }
  }

  function clearChangeQueue(value) {
    const isQuarentineZone = tabWaitingInfo.isActive || tabChatsInfo.isActive;
    //se for a fila normal vai setar o valor de filterQueue
    if (!isQuarentineZone) {
      setFilterQueue(value);
      if (value !== "") {
        setKeyQueue([]);
      } else {
        setKeyQueue(auxkeyQueue);
      }
    } else {
      this.setState({ filterQuarentineQueue: value });
      setFilterQuarentineQueue(value);
    }
  }

  function handleCheckAll(e, type) {
    if (type === "status") {
      let newStatusStorage = [];
      statusQueue.forEach((datum) => {
        if (e.target.checked) {
          document.getElementById(`checkbox-status-${datum.id}`).checked = true;
          newStatusStorage.push(datum.id);
          setTextStatusCheck("Desmarcar todos");
        } else {
          document.getElementById(`checkbox-status-${datum.id}`).checked =
            false;
          // filterstatusstorage = [];
          setTextStatusCheck("Marcar todos");
        }
      });
      filterstatusstorage = newStatusStorage;
      setFilterStatusStorage(newStatusStorage);
    } else if (type === "media") {
      let newMediaStorage = [];
      midias.forEach((datum) => {
        if (e.target.checked) {
          setTextMediaCheck("Desmarcar todos");
          // document.getElementById(`checkbox-media-all`).checked = false;
          document.getElementById(`checkbox-media-${datum.id}`).checked = true;
          newMediaStorage.push(datum.id);
        } else {
          // document.getElementById(`checkbox-media-all`).checked = false;
          setTextMediaCheck("Marcar todos");
          document.getElementById(`checkbox-media-${datum.id}`).checked = false;
          // filtermediastorage = [];
        }
      });
      filtermediastorage = newMediaStorage;
      setFilterMediaStorage(newMediaStorage);
    } else if (type === "subservice") {
      let newSubserviceStorage = [];
      subservicesList.forEach((datum) => {
        if (e.target.checked) {
          setTextSubserviceCheck("Desmarcar todos");
          document.getElementById(`checkbox-subservice-${datum.id}`).checked =
            true;
          newSubserviceStorage.push(datum.id);
        } else {
          setTextSubserviceCheck("Marcar todos");
          document.getElementById(`checkbox-subservice-${datum.id}`).checked =
            false;
          // filtersubservicestorage = [];
        }
      });
      filtersubservicestorage = newSubserviceStorage;
      setFilterSubserviceStorage(newSubserviceStorage);
    }
  }

  function handleCheckAllQuarentine(e, type) {
    if (type === "media") {
      let newMediaStorage = [];
      midias.forEach((datum) => {
        if (e.target.checked) {
          setTextMediaCheckQuarentine("Desmarcar todos");
          // document.getElementById(`checkbox-media-all`).checked = false;
          document.getElementById(
            `checkbox-media-quarentine-${datum.id}`,
          ).checked = true;
          newMediaStorage.push(datum.id);
        } else {
          // document.getElementById(`checkbox-media-all`).checked = false;
          setTextMediaCheckQuarentine("Marcar todos");
          document.getElementById(
            `checkbox-media-quarentine-${datum.id}`,
          ).checked = false;
          // filtermediastorage = [];
        }
      });
      setFilterMediaStorageQuarentine(newMediaStorage);
      localStorage.setItem(
        "clients_queue-quarentine_media",
        JSON.stringify(newMediaStorage),
      );
    }
  }

  function getFilterQueue(e, idqueue) {
    let filtro = typequeue;
    if (e.target.checked) {
      setTypeQueue((prevState) => prevState.concat([idqueue]));
      localStorage.setItem("filtro_fila", filtro.concat([idqueue]));
      saveTostorage(idqueue, true);
    } else {
      setTypeQueue((prevState) =>
        prevState.filter(function (val) {
          return val !== idqueue;
        }),
      );
      localStorage.setItem(
        "filtro_fila",
        filtro.filter(function (val) {
          return val !== idqueue;
        }),
      );
      saveTostorage(idqueue, false);
    }
  }

  function saveTostorage(idqueue, value) {
    switch (idqueue) {
      case "0":
        localStorage.setItem("fila_checkbox_callback", value);
        dispatch(callbackChange(value));
        break;
      case "1":
        localStorage.setItem("fila_checkbox_espera", value);
        dispatch(filaChange(value));
        break;
      case "2":
        localStorage.setItem("fila_checkbox_em_tratamento", value);
        dispatch(tratamentoChange(value));
        break;
      case "5":
        localStorage.setItem("fila_checkbox_retorno", value);
        dispatch(retornoChange(value));
        break;
      default:
        break;
    }
  }

  function setVisibleDrawer() {
    setOpenDrawer(false);
  }

  function getCanais() {
    let canais = filtrosDeFila.canais;
    for (const key in canais) {
      const hasThisChannelInFilterMediaStorage = filterMediaStorage.includes(
        parseInt(key),
      );
      canais[key] = hasThisChannelInFilterMediaStorage ? true : false;
    }
    return canais;
  }
  function limparCanais() {
    let canais = filtrosDeFila.canais;
    for (const key in canais) {
      canais[key] = false;
    }
    return canais;
  }
  function getSubservico() {
    let subservico = filtrosDeFila.subservico;
    for (const key in subservico) {
      const hasThisServiceInFilterSubserviceStorage =
        filterSubserviceStorage.includes(parseInt(key));
      subservico[key] = hasThisServiceInFilterSubserviceStorage ? true : false;
    }
    return subservico;
  }
  function limparSubservico() {
    let subservico = filtrosDeFila.subservico;
    for (const key in subservico) {
      subservico[key] = false;
    }
    return subservico;
  }
  function getStatus() {
    let status = filtrosDeFila.status;
    for (const key in status) {
      const hasThisStatusInFilterStatusStorage = filterStatusStorage.includes(
        STATUS_ID_MAPPING[key],
      );
      status[key] = hasThisStatusInFilterStatusStorage ? true : false;
    }
    return status;
  }
  function limparStatus() {
    let status = filtrosDeFila.status;
    for (const key in status) {
      status[key] = false;
    }
    return status;
  }

  function InsertFiltersInDb() {
    try {
      const canais = getCanais();
      const subservico = getSubservico();
      const status = getStatus();
      const newFiltrosDeFila = {
        canais,
        subservico,
        status,
      };
      dispatch(AdicionarValoresIniciaisDoFiltroDeFila(newFiltrosDeFila));
      const userId = Boolean(InfoUsers) ? InfoUsers.id : null;
      updateUserFilters(userId, newFiltrosDeFila);
    } catch (error) {
      console.log("InsertFiltersInDb Error: ", error);
    }
  }

  function ClearFiltersInDb() {
    try {
      const canais = limparCanais();
      const subservico = limparSubservico();
      const status = limparStatus();
      const newFiltrosDeFila = {
        canais,
        subservico,
        status,
      };
      dispatch(AdicionarValoresIniciaisDoFiltroDeFila(newFiltrosDeFila));
      // const userId = Boolean(InfoUsers) ? InfoUsers.id : null;
      // updateUserFilters(userId, newFiltrosDeFila);
    } catch (error) {
      console.log("ClearFiltersInDb Error: ", error);
    }
  }

  function applyAllFields() {
    try {
      applyFilterMedia();
      applyFilterStatus();
      applyFilterSubservice();
      InsertFiltersInDb();
      setIsViewStatus(false);
      setIsViewChannels(false);
      setIsViewSubservices(false);
      setInitialDateAfter(initialDate);
      setFinalDateAfter(finalDate);
      setVisibleDrawer();
    } catch (error) {
      console.log("applyAllFields Error: ", error);
    }
  }

  // function applyAllFields() {
  //   if (tabNextCallInfo.isActive) {
  //     applyFilterMedia();
  //     applyFilterStatus();
  //     applyFilterSubservice();
  //     InsertFiltersInDb();
  //     setIsViewStatus(false);
  //     setIsViewChannels(false);
  //     setIsViewSubservices(false);
  //     setInitialDateAfter(initialDate);
  //     setFinalDateAfter(finalDate);
  //     setVisibleDrawer();
  //   } else {
  //     setIsViewStatus(false);
  //     setIsViewChannels(false);
  //     setIsViewSubservices(false);
  //     setVisibleDrawer();
  //   }
  // }

  function clearFilterMedia() {
    // setTypeMedia(filtermediastorage);
    setTypeMedia([]);
    // localStorage.setItem("clients_queue_media", filtermediastorage);
    localStorage.setItem("clients_queue_media", []);
  }

  function applyFilterMedia() {
    // setTypeMedia(filtermediastorage);
    setTypeMedia(filterMediaStorage);
    // localStorage.setItem("clients_queue_media", filtermediastorage);
    localStorage.setItem("clients_queue_media", filterMediaStorage);
  }

  function clearFilterStatus() {
    setTypeStatus([]);
    dispatch(arrayChange([]));

    // localStorage.setItem("clients_queue_status", filterstatusstorage);
    localStorage.setItem("clients_queue_status", []);
  }

  function applyFilterStatus() {
    setTypeStatus(filterStatusStorage);

    dispatch(arrayChange(filterStatusStorage));

    // localStorage.setItem("clients_queue_status", filterstatusstorage);
    localStorage.setItem("clients_queue_status", filterStatusStorage);
  }

  function clearFilterSubservice() {
    // setTypeSubservice(filtersubservicestorage);
    setTypeSubservice([]);
    // localStorage.setItem("clients_queue_subservice", filtersubservicestorage);
    localStorage.setItem("clients_queue_subservice", []);
  }

  function applyFilterSubservice() {
    // setTypeSubservice(filtersubservicestorage);
    setTypeSubservice(filterSubserviceStorage);
    // localStorage.setItem("clients_queue_subservice", filtersubservicestorage);
    localStorage.setItem("clients_queue_subservice", filterSubserviceStorage);
  }

  function clearclearAllFieldsQuarentine() {
    midias.forEach((datum) => {
      document.getElementById(`checkbox-media-quarentine-${datum.id}`).checked =
        false;
    });
    //ttk
    setIsViewStatus(false);
    setIsViewChannels(false);
    setIsViewSubservices(false);
    setTextMediaCheckQuarentine("Marcar todos");
    setFilterMediaStorageQuarentine([]);
    setInitialDateQuarentine(new Date().setDate(new Date().getDate() - 30));
    setFinalDateQuarentine(new Date());
    localStorage.setItem("clients_queue-quarentine_media", JSON.stringify([]));
    setVisibleDrawer();
  }

  function clearAllFields() {
    try {
      statusQueue.forEach((datum) => {
        document.getElementById(`checkbox-status-${datum.id}`).checked = false;
      });
      midias.forEach((datum) => {
        document.getElementById(`checkbox-media-${datum.id}`).checked = false;
      });
      subservicesList.forEach((datum) => {
        document.getElementById(`checkbox-subservice-${datum.id}`).checked =
          false;
      });
      filtersubservicestorage = [];
      filtermediastorage = [];
      filterstatusstorage = [];
      setFilterSubserviceStorage([]);
      setFilterMediaStorage([]);
      setFilterStatusStorage([]);
      // applyFilterMedia();
      clearFilterMedia();
      // applyFilterStatus();
      clearFilterStatus();
      // applyFilterSubservice();
      clearFilterSubservice();
      setIsViewStatus(false);
      setIsViewChannels(false);
      setIsViewSubservices(false);
      setTextMediaCheck("Marcar todos");
      setTextSubserviceCheck("Marcar todos");
      setTextStatusCheck("Marcar todos");
      setInitialDateAfter(initialDateLater);
      setFinalDateAfter(new Date());
      setInitialDate(initialDateLater);
      setFinalDate(new Date());
      document.getElementById(`checkbox-status-all`).checked = false;
      document.getElementById(`checkbox-media-all`).checked = false;
      document.getElementById(`checkbox-subservice-all`).checked = false;
      ClearFiltersInDb();
      setVisibleDrawer();
    } catch (error) {
      console.log("clearAllFields Error: ", error);
    }
  }
  // function clearAllFields() {
  //   statusQueue.forEach((datum) => {
  //     document.getElementById(`checkbox-status-${datum.id}`).checked = false;
  //   });
  //   midias.forEach((datum) => {
  //     document.getElementById(`checkbox-media-${datum.id}`).checked = false;
  //   });
  //   subservicesList.forEach((datum) => {
  //     document.getElementById(
  //       `checkbox-subservice-${datum.id}`
  //     ).checked = false;
  //   });
  //   filtersubservicestorage = [];
  //   filtermediastorage = [];
  //   filterstatusstorage = [];
  //   setFilterSubserviceStorage([]);
  //   setFilterMediaStorage([]);
  //   setFilterStatusStorage([]);
  //   // applyFilterMedia();
  //   clearFilterMedia();
  //   // applyFilterStatus();
  //   clearFilterStatus();
  //   // applyFilterSubservice();
  //   clearFilterSubservice();
  //   setIsViewStatus(false);
  //   setIsViewChannels(false);
  //   setIsViewSubservices(false);
  //   setTextMediaCheck("Marcar todos");
  //   setTextSubserviceCheck("Marcar todos");
  //   setTextStatusCheck("Marcar todos");
  //   setInitialDateAfter(initialDateLater);
  //   setFinalDateAfter(new Date());
  //   setInitialDate(initialDateLater);
  //   setFinalDate(new Date());
  //   document.getElementById(`checkbox-status-all`).checked = false;
  //   document.getElementById(`checkbox-media-all`).checked = false;
  //   document.getElementById(`checkbox-subservice-all`).checked = false;
  //   setVisibleDrawer();
  // }

  function getFilterMedia(e, idmedia) {
    let filterMedia = filterMediaStorage;
    if (e.target.checked) {
      filterMedia = filterMedia.concat([idmedia]);
      if (filterMedia.length === midias.length) {
        setTextMediaCheck("Desmarcar todos");
        document.getElementById(`checkbox-media-all`).checked = true;
      }
    } else {
      filterMedia = filterMedia.filter(function (val) {
        return val !== idmedia;
      });
      document.getElementById(`checkbox-media-all`).checked = false;
      setTextMediaCheck("Marcar todos");
    }
    setFilterMediaStorage(filterMedia);
  }

  function getFilterMediaQuarentine(e, idmedia) {
    let updatedFiltermediastorageQuarentine = filtermediastorageQuarentine;
    if (e.target.checked) {
      updatedFiltermediastorageQuarentine =
        updatedFiltermediastorageQuarentine.concat([idmedia]);
      if (filtermediastorageQuarentine.length === midias.length) {
        setTextMediaCheckQuarentine("Desmarcar todos");
        document.getElementById(`checkbox-media-all-quarentine`).checked = true;
      }
    } else {
      updatedFiltermediastorageQuarentine =
        updatedFiltermediastorageQuarentine.filter(function (val) {
          return val !== idmedia;
        });
      document.getElementById(`checkbox-media-all-quarentine`).checked = false;
      setTextMediaCheckQuarentine("Marcar todos");
    }
    setFilterMediaStorageQuarentine(updatedFiltermediastorageQuarentine);
    localStorage.setItem(
      "clients_queue-quarentine_media",
      JSON.stringify(updatedFiltermediastorageQuarentine),
    );
  }

  function getFilterStatus(e, idstatus) {
    let filterStatus = filterStatusStorage;
    if (e.target.checked) {
      filterStatus = filterStatus.concat([idstatus]);
      if (filterStatus.length === statusQueue.length) {
        setTextStatusCheck("Desmarcar todos");
        document.getElementById(`checkbox-status-all`).checked = true;
      }
    } else {
      filterStatus = filterStatus.filter(function (val) {
        return val !== idstatus;
      });
      document.getElementById(`checkbox-status-all`).checked = false;
      setTextStatusCheck("Marcar todos");
    }
    setFilterStatusStorage(filterStatus);
  }

  function getFilterSubservice(e, serviceinid) {
    let filterSubservice = filterSubserviceStorage;
    if (e.target.checked) {
      filterSubservice = filterSubservice.concat([serviceinid]);
      if (filterSubservice.length === subservicesList.length) {
        setTextSubserviceCheck("Desmarcar todos");
        document.getElementById(`checkbox-subservice-all`).checked = true;
      }
    } else {
      filterSubservice = filterSubservice.filter(function (val) {
        return val !== serviceinid;
      });
      document.getElementById(`checkbox-subservice-all`).checked = false;
      setTextSubserviceCheck("Marcar todos");
    }
    setFilterSubserviceStorage(filterSubservice);
  }

  function DisplayDetailsIn(event, idqueue) {
    event.preventDefault();
    setButtonDetailsIn((prevState) => !prevState);
    setQueueId(idqueue);
  }

  const checkExpandQueue = (e, idqueue) => {
    var checkClick = expandQueue.indexOf(idqueue) !== -1 ? true : false;

    if (!checkClick) {
      setExpandQueue((prevState) => prevState.concat([idqueue]));
    } else {
      setExpandQueue((prevState) =>
        prevState.filter(function (val) {
          return val !== idqueue;
        }),
      );
    }
  };

  function buttonSearchAnotation(e, telefone) {
    let erro = 0;
    let now = Moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = Moment().format("YYYY-MM-DD");
    const idcriticidade = idCrit;

    let comparation = Moment(datainit).isBefore(datafim);

    if (datainit === "") erro = 1;

    if (datafim === "") erro = 1;

    if (comparation === false) {
      erro = 1;
      if (datainit === datafim) {
        erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(
        DetailsAnotationsida(datainit, datafim, idcriticidade, telefone),
      );
    }
  }

  function buttonSearchFileCompart(e, telefone) {
    let erro = 0;
    let now = Moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = Moment().format("YYYY-MM-DD");
    const formats =
      "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28";
    const midias = "2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18";

    const comparation = Moment(datainit).isBefore(datafim);

    if (datainit === "") erro = 1;

    if (datafim === "") erro = 1;

    if (formats === "") erro = 1;

    if (midias === "") erro = 1;

    if (comparation === false) {
      erro = 1;
      if (datainit === datafim) {
        erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(
        DetailsFileSharedIn(datainit, datafim, formats, midias, telefone),
      );
    }
  }

  function buttonSearchMarkstar(e, telefone) {
    let erro = 0;
    let now = Moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = Moment().format("YYYY-MM-DD");

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit === "") erro = 1;

    if (datafim === "") erro = 1;

    if (comparation === false) {
      erro = 1;
      if (datainit === datafim) {
        erro = 0;
      }
    }

    if (erro === 0) {
      dispatch(DetailsMarkstarida(datainit, datafim, telefone));
    }
  }

  const SolicitarChamadaAtiva = (
    e,
    permrouter,
    mediaid,
    callStatus,
    infouser,
    number,
    outband,
    queue,
    AtdSimult,
    ipcurrent,
    statusAgent,
  ) => {
    document.getElementById("div_alert").innerHTML = "";

    if (ContactId.length !== 0) {
      localStorage.setItem("current-service", ContactId.idatendimento);
    }

    if (statusAgent.allowCall === false) {
      dispatch(InterationNotifier("Pausa não permite ativo", "permission"));
      return true;
    }

    const chatMessage = document.getElementById("chat-message");
    if (chatMessage) chatMessage.innerText = "";

    if (!permrouter || permrouter.length === 0) return;

    let chamado = number.replace(/\D/g, "");
    let tipochamada = 0;
    let DDD = permrouter[0].areacodeid || "71";

    const valorfixo = [1, 2, 3, 4],
      valormovel = [5, 6, 7, 8, 9];
    const removeDigits =
      connection_platform.remove_digits || parseInt(mediaid) !== 1;

    if (
      removeDigits &&
      chamado.startsWith("0") &&
      !chamado.startsWith("00") &&
      !chamado.startsWith("0800")
    ) {
      chamado = chamado.substring(1);
    }

    function definirTipoChamada(mediaid, tipo) {
      const tipos = {
        fixoInterurbano: [3, 17, 19, 18, 20, 21, 23, 22, 24, 25],
        movelInterurbano: [4, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
        fixoLocal: [1, 17, 19, 18, 20, 21, 23, 22, 24, 25],
        movelLocal: [2, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
      };

      // Converte mediaid para inteiro
      const midiaConvertida = parseInt(mediaid, 10);

      // Se mediaid for 1, busca no objeto `tipos`, senão segue a lógica específica
      if (midiaConvertida === 1) {
        return tipos[tipo] ? tipos[tipo][midiaConvertida - 1] || 0 : 0;
      } else {
        const mapeamentoMidia = {
          2: 24,
          3: 22,
          4: 18,
          5: 17,
          6: 20,
          8: 19,
          9: 21,
          10: 23,
          12: 13,
          15: 26,
        };

        return mapeamentoMidia[midiaConvertida] || midiaConvertida;
      }
    }

    if (
      (chamado.length >= 10 || chamado.length === 8 || chamado.length === 9) &&
      !chamado.startsWith("00")
    ) {
      if (
        chamado.startsWith("55") &&
        (mediaid === 5 || mediaid === "5") &&
        chamado.length > 11
      )
        chamado = chamado.substr(2);
      if (chamado.length === 8 || chamado.length === 9) chamado = DDD + chamado;
    }

    let chamadoValidado = chamado.replace(/^0(?!0|800|300)/, "");
    console.log("INGENIUM_ACTVECALL_0 : ", chamado);

    let dddValidado =
      chamadoValidado.length >= 10 ? chamadoValidado.substr(0, 2) : "";

    console.log("INGENIUM_ACTVECALL_1 : ", chamadoValidado);

    if (
      chamadoValidado.length >= 10 &&
      !chamadoValidado.startsWith("00") &&
      !chamadoValidado.startsWith("0800")
    ) {
      if (valorfixo.includes(parseInt(chamadoValidado[2]))) {
        tipochamada = definirTipoChamada(
          mediaid,
          dddValidado && parseInt(dddValidado) !== parseInt(DDD)
            ? "fixoInterurbano"
            : "fixoLocal",
        );
      } else if (valormovel.includes(parseInt(chamadoValidado[2]))) {
        tipochamada = definirTipoChamada(
          mediaid,
          dddValidado && parseInt(dddValidado) !== parseInt(DDD)
            ? "movelInterurbano"
            : "movelLocal",
        );
      }
    } else if (chamadoValidado.startsWith("0800")) {
      tipochamada = 8;
    } else if (chamadoValidado.startsWith("00")) {
      tipochamada = 5;
    }

    console.log("INGENIUM_ACTVECALL_2 : ", tipochamada);

    function buscarRota() {
      let rota = [];

      console.log("INGENIUM_ACTVECALL_1 : ", permrouter);

      const doisPrimeirosDigitos = chamadoValidado.substring(0, 2);

      // Só verifica `areacode` se `mediaid` for 1
      const verificarAreacode = parseInt(mediaid) === 1;

      // Verifica se existe pelo menos um item com areacode correspondente (somente se `mediaid` for 1)
      const existeAreaCode = verificarAreacode
        ? permrouter.some(
            (result) =>
              result.areacode &&
              String(result.areacode).startsWith(doisPrimeirosDigitos),
          )
        : false;

      permrouter.forEach((result) => {
        if (
          result.calltypeid === tipochamada &&
          parseInt(result.idmidia) === parseInt(mediaid) &&
          (!verificarAreacode ||
            !existeAreaCode ||
            (result.areacode &&
              String(result.areacode).startsWith(doisPrimeirosDigitos)))
        ) {
          rota.push(result);
        }
        if (result.calltypeid === 11 && !rota) {
          if (
            parseInt(chamado) >= parseInt(result.partialnumber) &&
            parseInt(chamado) <= parseInt(result.partialnumber_end)
          ) {
            rota.push(result);
          }
        } else if (result.calltypeid === 6 && !rota) {
          if (parseInt(chamado) === parseInt(result.partialnumber)) {
            rota.push(result);
          }
        }
      });

      if (rota && rota.length > 1) {
        let isExistOther = false;
        rota.forEach((result) => {
          const lastEight = String(chamado).slice(-8);
          if (
            parseInt(lastEight) >= parseInt(result.partialnumber) &&
            parseInt(lastEight) <= parseInt(result.partialnumber_end)
          ) {
            rota = result;
            isExistOther = true;
          }
        });
        if (!isExistOther) {
          rota = rota.filter((temp) => temp.isdefault === "t");
          rota = rota.length !== 0 ? rota[0] : [];
        }
      } else if (rota.length === 1) {
        rota = rota[0];
      }

      return rota;
    }

    const rotaEncontrada = buscarRota();

    console.log("INGENIUM_ACTVECALL_4 : ", rotaEncontrada);

    if (rotaEncontrada.length === 0) {
      setSenhaIncorreta("block");
      document.getElementById("div_alert").innerHTML = "Sem rota de saída!";
      return;
    }

    let retorno = 1;
    let queueid = queue && queue.queueid ? queue.queueid : null;
    let recvcount = queue && queue.recv_count ? queue.recv_count : null;
    let cdrid = queue && queue.cdrid ? queue.cdrid : null;
    let srvin = queue && queue.serviceinid ? queue.serviceinid : null;
    let caller = queue && queue.caller ? queue.caller : null;
    let called = queue && queue.called ? queue.called : null;
    let cbackcount =
      queue && queue.callback_count ? queue.callback_count : null;
    let queueStatus = queue && queue.status ? queue.status : null;
    let tech = rotaEncontrada.tech;
    let idgrupo_rota = rotaEncontrada.idgrupo_rota;
    let idgrupo_transb = rotaEncontrada.idgrupo_transb;
    let checkRota = true;

    if (mediaid === 5 || mediaid === 8) {
      chamado = chamado.trim();
    }

    console.log("INGENIUM_ACTVECALL_5 : ", chamado);

    const ReturningCallbackIn = (
      queueid,
      inforetorno,
      recvcount,
      cdrid,
      mediaid,
      srvin,
      caller,
      called,
      callback_count,
      status,
    ) => {
      if (status !== 2 || status !== "2") {
        dispatch(
          returnListCallQueue(
            "",
            queueid,
            "2",
            parseInt(callback_count + 1),
            "você",
          ),
        );
      }
    };

    if (mediaid === 1) {
      dispatch(
        RequestActiveCallSocketVoz(
          outband,
          infouser,
          rotaEncontrada.idtrunk,
          mediaid,
          chamado,
          rotaEncontrada.addtech,
          rotaEncontrada.scripttrunk,
          rotaEncontrada.operator,
          true,
          queueid,
          recvcount,
          null,
          tech,
          idgrupo_rota,
          idgrupo_transb,
          ipcurrent,
          cdrid,
          checkRota,
        ),
      );
      ReturningCallbackIn(
        queueid,
        true,
        recvcount,
        cdrid,
        mediaid,
        srvin,
        caller,
        called,
        cbackcount,
        queueStatus,
      );
    } else {
      dispatch(
        RequestActiveCall(
          outband,
          infouser,
          rotaEncontrada.idtrunk,
          mediaid,
          chamado,
          rotaEncontrada.addtech,
          rotaEncontrada.scripttrunk,
          rotaEncontrada.operator,
          true,
          queueid,
          recvcount,
          cbackcount,
          idgrupo_transb,
          cdrid,
        ),
      );
      ReturningCallbackIn(
        queueid,
        true,
        recvcount,
        cdrid,
        mediaid,
        srvin,
        caller,
        called,
        cbackcount,
        queueStatus,
      );
    }
    dispatch(ShowInfoDisplay("Clientes"));
  };

  function ShowVisible(display) {
    dispatch(ShowVisibleNextAtd(display, display));
    // MicroModal.show('modal__encerrar-atendimento')
  }

  function RefreshNoAnswer(e, cdrid, queueid, infousers, queue) {
    dispatch(ActionRefreshNoAnswer(queueid));
    RefreshNoAnswerCall(cdrid, queueid, infousers, queue);
    document.getElementById("simulation_click").click();
  }

  const renderPopover = (
    e,
    numberqueue,
    contactname,
    cdrid,
    queueid,
    queue,
    infousers,
    actionPermission,
  ) => {
    return (
      <div className="context-menu new-context" id="info-fila">
        <ul className="context-menu__list">
          {(() => {
            if (!actionPermission) {
              return (
                <>
                  {infousers.view_queue_interaction === true && (
                    <li
                      className="context-menu__item"
                      onClick={(event) =>
                        ShowModals(
                          event,
                          numberqueue,
                          contactname,
                          "modal__historico-atendimento-queue",
                          cdrid,
                          queueid,
                          queue,
                        )
                      }
                    >
                      <Interacoes />
                      <span className="context-menu_link">Interações</span>
                    </li>
                  )}
                  <li
                    className="context-menu__item"
                    onClick={(event) =>
                      ShowModals(
                        event,
                        numberqueue,
                        contactname,
                        "modal__anotacoes",
                        cdrid,
                        queueid,
                        queue,
                      )
                    }
                  >
                    <Anotacoes />
                    <span className="context-menu_link">Anotações</span>
                  </li>

                  <li
                    className="context-menu__item"
                    onClick={(event) =>
                      ShowModals(
                        event,
                        numberqueue,
                        contactname,
                        "modal__mensagens-favoritas",
                        cdrid,
                        queueid,
                        queue,
                      )
                    }
                  >
                    <MsgFavoritas />
                    <span className="context-menu_link">
                      Mensagens favoritas
                    </span>
                  </li>
                  <li
                    className="context-menu__item"
                    onClick={(event) =>
                      ShowModals(
                        event,
                        numberqueue,
                        contactname,
                        "modal__arquivos-compartilhados",
                        cdrid,
                        queueid,
                        queue,
                      )
                    }
                  >
                    <ArquivosComp />
                    <span className="context-menu_link">
                      Arquivos compartilhados
                    </span>
                  </li>
                </>
              );
            } else {
              return (
                <>
                  {parseInt(queue.status) === 1 && (
                    <li
                      className="context-menu__item"
                      onClick={(event) =>
                        ShowModals(
                          event,
                          numberqueue,
                          contactname,
                          "modal__transferir__chamada",
                          cdrid,
                          queueid,
                          queue,
                        )
                      }
                    >
                      <Transferir />
                      <span className="context-menu_link">Transferir</span>
                    </li>
                  )}

                  {infousers.supervisor === true && queue.status !== "1" && (
                    <li
                      className="context-menu__item item-excluir"
                      onClick={(event) =>
                        ShowModals(
                          event,
                          numberqueue,
                          contactname,
                          "modal__excluir",
                          cdrid,
                          queueid,
                          queue,
                        )
                      }
                    >
                      <AlterarExcluir />
                      <span className="context-menu_link">Excluir chamada</span>
                    </li>
                  )}

                  {infousers.supervisor === true && queue.status !== "0" && (
                    <li
                      className="context-menu__item"
                      onClick={(event) =>
                        RefreshNoAnswer(event, cdrid, queueid, infousers, queue)
                      }
                    >
                      <AlterarExcluir />
                      <span className="context-menu_link">
                        Alterar para não atendida
                      </span>
                    </li>
                  )}
                </>
              );
            }
          })()}
        </ul>
      </div>
    );
  };

  function ShowCriticitys(e) {
    e.preventDefault();
    setButtonShowCriticits(!buttonShowCriticits);
  }

  function SelectCriticitys(
    e,
    desccriticidade,
    idcriticidade,
    tipocriticidade,
  ) {
    setCritSelec(desccriticidade);
    setIconCrit(tipocriticidade);
    setIdCrit(idcriticidade);
    setButtonShowCriticits(!buttonShowCriticits);
  }

  function SelectCriticitys2(
    e,
    desccriticidade,
    idcriticidade,
    tipocriticidade,
  ) {
    setSelecCritic(desccriticidade);
    setIdCrit2(idcriticidade);
    setButtonShowCriticits(!buttonShowCriticits);
  }

  function ShowModals(
    e,
    numberqueue,
    contactname,
    modal,
    cdrid,
    queueid,
    queue,
  ) {
    ShowNameCli(numberqueue, contactname);
    setModalOpen(modal);
    setQueueModalOpen(queueid);
    dispatch(GetInteractionsModal(contactname, numberqueue));

    switch (modal) {
      case "modal__anotacoes":
        buttonSearchAnotation(e, numberqueue);
        MicroModal.show("modal__anotacoes-details-new");
        break;
      case "modal__arquivos-compartilhados":
        buttonSearchFileCompart(e, numberqueue);
        MicroModal.show("modal__arquivos-compartilhados-details");
        break;
      case "modal__mensagens-favoritas":
        buttonSearchMarkstar(e, numberqueue);
        MicroModal.show("modal__mensagens-favoritas-details");
        break;
      case "modal__historico-atendimento-queue":
        dispatch(GetHistory([]));
        const agora = Moment().subtract(7, "days");
        let histstart = agora.format("YYYY-MM-DDT00:00");
        let histend = Moment().format("YYYY-MM-DDT23:59");

        DisplayHistoric(numberqueue);
        MicroModal.show("modal__historico-atendimento-details");
        // this.setState({
        //   clientpdf: numberqueue,
        //   datapdfend: histend,
        //   datapdfinit: histstart,
        //   cliente: contactname,
        // });

        break;
      case "modal__excluir":
        setDeletequeueid(cdrid);
        setDeletecdrid(queueid);
        setMediaid(queue.mediaid);
        MicroModal.show("modal__excluir");

        break;
      case "modal__transferir__chamada":
        setCdrid(cdrid);
        setScriptid(queue.scriptid);
        setMediaid(queue.mediaid);
        setQueueId(queueid);
        MicroModal.show("modal__transferir__chamada");
        break;
      default:
        break;
    }
  }

  function ShowNameCli(numberqueue, contactname) {
    setNumberqueue(numberqueue);
    if (contactname) {
      var mensagem_tratada = createJSON(contactname);
      setNameCli(mensagem_tratada);
    } else {
      setNameCli(numberqueue);
    }
  }

  function SearchInHistory(e) {
    e.preventDefault();
    setShowHistory(!showHistory);
  }

  function checkExpandLearnQueue(e, idanot) {
    var checkClick = expandLearn.indexOf(idanot) !== -1 ? true : false;

    if (!checkClick) {
      setExpandLearn(expandLearn.concat([idanot]));
    } else {
      setExpandLearn(
        expandLearn.filter(function (val) {
          return val !== idanot;
        }),
      );
    }
  }

  function showExpandVisual(e, idarq) {
    var click = optionsActionsFile.indexOf(idarq) !== -1 ? true : false;

    if (!click) {
      setOptionsActionsFile(optionsActionsFile.concat([idarq]));
    } else {
      setOptionsActionsFile(
        optionsActionsFile.filter(function (val) {
          return val !== idarq;
        }),
      );
    }
  }

  function ShowChoiceFormat(e) {
    e.preventDefault();
    setButtonShowFormatsFile(!buttonShowFormatsFile);
  }

  function choiceFormat(event, formats, name) {
    // this.mimetypeids.value = formats;
    setButtonShowFormatsFile(!buttonShowFormatsFile);
    setDefaultValueFormat(name);
  }

  function choiceMidia(event, midias, name) {
    // this.midias.value = midias;
    setButtonShowMidias(!buttonShowMidias);
    setDefaultValueMidias(name);
  }

  function ShowChoiceMidias(e) {
    e.preventDefault();
    setButtonShowMidias(!buttonShowMidias);
  }

  function DonwloadFile(e, url, name) {
    e.preventDefault();
    dispatch(DownloadFile(url, name));
  }

  const handleScroll = (e) => {
    let element = e.target;
    let elmnt = document.getElementsByClassName("time");
  };

  function VerifierImage(e, urlimage, modal) {
    setIsOpen(true);
    setUrlImage(urlimage);
    if (modal === "history") {
      MicroModal.close("modal__historico-atendimento-queue");
    }
    if (modal === "dmark") {
      MicroModal.close("modal__mensagens-favoritas");
    }
  }

  function CloseImage(e, modal) {
    setIsOpen(false);
    setUrlImage("");
    if (modal === "history") {
      MicroModal.show("modal__historico-atendimento-queue");
    }
    if (modal === "dmark") {
      MicroModal.show("modal__mensagens-favoritas");
    }
  }

  const ScrollView = (e) => {
    let element = e.target;
    let valueScroll = element.scrollTop + element.clientHeight;
    if (element.scrollHeight === valueScroll) {
      setScrollEnd((prevState) => prevState + 4);
    }
  };

  function RemoveAllFilterQueue(e) {
    let array = typequeue;
    for (let i = 0; i < array.length; i++) {
      var myCheckbox = document.getElementById("input" + array[i]);
      myCheckbox.checked = false;
    }
    localStorage.setItem("filtro_fila", []);
  }

  function RemoveAllFilterMedia(e) {
    let array = midias;
    for (let i = 0; i < array.length; i++) {
      var myCheckbox = document.getElementById("input" + array[i].describer);
      myCheckbox.checked = false;
    }
    localStorage.setItem("clients_queue_media", []);
  }

  const SolicitarChamada = (
    InfoUsers,
    scriptid,
    cdrid,
    mediaid,
    status,
    StatusAgent,
  ) => {
    if (StatusAgent.allowCapture === false) {
      dispatch(InterationNotifier("Pausa não permite captura", "permission"));
    } else {
      dispatch(SolicitarChamadaIn(InfoUsers, scriptid, cdrid, mediaid));
    }
  };

  const saveFiltersOptions = (status, channels, subservices) => {
    if (status && filterStatusStorage.length === 0) {
      const checkStatus = status.forEach((stat) => {
        const findStatus = document.getElementById(`checkbox-status-${stat}`);
        if (findStatus) findStatus.checked = true;
      });
      setFilterStatusStorage(status);
      setTypeStatus(status);
      localStorage.setItem("clients_queue_status", status.join());
    } else if (channels && filterMediaStorage.length === 0) {
      const hasCanais = Array.isArray(channels.midias);
      const getMidiasId = hasCanais
        ? channels.midias.map((midia) => midia.id)
        : [];
      setFilterMediaStorage(getMidiasId);
      setTypeMedia(getMidiasId);
      setTextMediaCheck("Desmarcar todos");
      localStorage.setItem("clients_queue_media", getMidiasId);
    } else if (subservices && filterSubserviceStorage.length === 0) {
      const getSubservId = subservices.map((subserv) => subserv.id);
      setFilterSubserviceStorage(getSubservId);
      setTypeSubservice(getSubservId);
      setTextSubserviceCheck("Desmarcar todos");
      localStorage.setItem("clients_queue_subservice", getSubservId);
    }
  };

  function renderItemQueue(
    IPCurrent,
    InfoUsers,
    StatusAgent,
    AtdSimult,
    OutBandService,
    PermissionRouter,
    callpark,
    initialDate,
    finalDate,
  ) {
    const ShowInfoDisplayIn = (post) => {
      dispatch(ShowInfoDisplay(post));
    };

    if (tabNextCallInfo.isActive) {
      return (
        <div
          style={{
            height: "100%",
            overflow: "hidden",
            padding: "0 16px",
          }}
        >
          <div
            className="block-content overflow flex-column list new"
            onScroll={ScrollView}
          >
            {callqueue.map((queue) => {
              const queueItemProps = {
                queue,
                IPCurrent,
                InfoUsers,
                StatusAgent,
                AtdSimult,
                OutBandService,
                PermissionRouter,
                expandQueue: expandQueue,
                buttonDetails: buttonDetails,
                callpark,
              };
              return (
                <QueueItem
                  key={queue.queueid}
                  checkExpandQueue={checkExpandQueue}
                  renderPopover={renderPopover}
                  SolicitarChamada={SolicitarChamada}
                  SolicitarChamadaAtiva={SolicitarChamadaAtiva}
                  ShowInfoDisplay={ShowInfoDisplayIn}
                  {...queueItemProps}
                />
              );
            })}
          </div>
        </div>
      );
    } else if (tabWaitingInfo.isActive) {
      return (
        <QuarentineZoneContent
          filteredListQuarentineQueue={filteredListQuarentineQueue}
          textToFilter={filterQuarentineQueue}
          filtermediastorage={filtermediastorage}
          initialDate={initialDate}
          finalDate={finalDate}
          onClickInFilter={() => setOpenDrawer(true)}
        />
      );
    } else {
      return (
        <ChatsContent
          key={filterQuarentineQueue}
          searchChats={filterQuarentineQueue}
          showModals={ShowModals}
        />
      );
    }
  }

  function onCloseDrawer() {
    try {
      setFilterMediaStorage(typemedia);
      setFilterStatusStorage(typestatus);
      setFilterSubserviceStorage(typesubservice);
      statusQueue.forEach((datum) => {
        const isOnTypeStatus = typestatus.includes(datum.id);
        document.getElementById(`checkbox-status-${datum.id}`).checked =
          isOnTypeStatus ? true : false;
      });
      midias.forEach((datum) => {
        const isOntypeMedia = typemedia.includes(datum.id);
        document.getElementById(`checkbox-media-${datum.id}`).checked =
          isOntypeMedia ? true : false;
      });
      subservicesList.forEach((datum) => {
        const isOnTypeSubservice = typesubservice.includes(datum.id);
        document.getElementById(`checkbox-subservice-${datum.id}`).checked =
          isOnTypeSubservice ? true : false;
      });

      if (typestatus.length === statusQueue.length) {
        setTextStatusCheck("Desmarcar todos");
        document.getElementById(`checkbox-status-all`).checked = true;
      } else {
        setTextStatusCheck("Marcar todos");
        document.getElementById(`checkbox-status-all`).checked = false;
      }

      if (typemedia.length === midias.length) {
        setTextMediaCheck("Desmarcar todos");
        document.getElementById(`checkbox-media-all`).checked = true;
      } else {
        setTextMediaCheck("Marcar todos");
        document.getElementById(`checkbox-media-all`).checked = false;
      }

      if (typesubservice.length === subservicesList.length) {
        setTextSubserviceCheck("Desmarcar todos");
        document.getElementById(`checkbox-subservice-all`).checked = true;
      } else {
        setTextSubserviceCheck("Marcar todos");
        document.getElementById(`checkbox-subservice-all`).checked = false;
      }
    } catch (error) {
      console.log("onCloseDrawer ERROR: ", error);
    }
  }

  function renderDrawer() {
    return (
      <Drawer
        onClose={onCloseDrawer}
        className="queue"
        filterApply={true}
        isOpen={openDrawer}
        setCloseDrawer={setVisibleDrawer}
        // bind={this}
        filtersActive={typequeue}
        cleanFilters={(e) => {
          clearAllFields();
        }}
        applyAllFields={applyAllFields}
        title="Filtros de Fila"
        newVersion={true}
      >
        <div className="drawer__queue-date">
          <FieldContainer
            title="Data início"
            className="case-client-queue"
            htmlFor=""
          >
            <DatePicker.DateRange
              selected={initialDate}
              setDate={(event) => {
                const newDate = event;
                setInitialDate(newDate);
              }}
              selectRangeType="start"
              endDate={finalDate}
              maxDate={finalDate}
              dateFormat={"dd/MM/yyyy"}
              showYearPicker={false}
            />
          </FieldContainer>

          <FieldContainer
            title="Data fim"
            className="case-client-queue"
            htmlFor=""
          >
            <DatePicker.DateRange
              selected={finalDate}
              setDate={(event) => {
                const newDate = event;
                setFinalDate(newDate);
              }}
              selectRangeType="end"
              startDate={initialDate}
              minDate={initialDate}
              dateFormat="dd/MM/yyyy"
              isClearable={false}
              showYearPicker={false}
            />
          </FieldContainer>
        </div>
        <div className="drawer__div__content-box queue">
          <span className="drawer__div__content-box__label">
            Status da Fila:
          </span>
          <div
            className={
              isViewStatus ? "select card--no-mg active" : "select card--no-mg"
            }
          >
            <button
              className="select__btn"
              type="button"
              id="mult-filter-inside"
              onClick={() => {
                setIsViewStatus(!isViewStatus);
                setIsViewChannels(false);
                setIsViewSubservices(false);
              }}
            >
              Selecione...
              <i className="select__icon material-icons">
                keyboard_arrow_right
              </i>
            </button>
            <div className="options options--advanced">
              <div className="options--advanced__filter-box">
                <div className="options--advanced__filter-box__content">
                  <div className="checkbox checkbox__list">
                    <div className="checkbox__list__title">
                      Status
                      <div className="checkbox-all">
                        <li className="checkbox__item-all">
                          <input
                            className="checkbox__list__input"
                            id={"checkbox-status-all"}
                            name={"checkbox-status-all"}
                            type="checkbox"
                            defaultChecked={
                              filterStatusStorage.length === statusQueue.length
                            }
                            checked={
                              filterStatusStorage.length === statusQueue.length
                            }
                            onChange={(event) =>
                              handleCheckAll(event, "status")
                            }
                          />
                          <label htmlFor={"checkbox-status-all"}>
                            {/* {filterstatusstorage.length === statusQueue.length
                                ? "Desmarcar todos"
                                : "Marcar todos"} */}
                            {textStatusCheck}
                          </label>
                        </li>
                      </div>
                    </div>
                    {statusQueue.map((status) => (
                      <li className="checkbox__item" key={status.id}>
                        <input
                          className="checkbox__list__input"
                          id={"checkbox-status-" + status.id}
                          name={"checkbox-status-" + status.id}
                          type="checkbox"
                          defaultChecked={
                            typestatus.findIndex(function (val) {
                              return parseInt(val) === parseInt(status.id);
                            }) !== -1
                            // ? true
                            // : false
                          }
                          onChange={(event) =>
                            getFilterStatus(event, status.id)
                          }
                        />
                        <label htmlFor={"checkbox-status-" + status.id}>
                          {status.title}
                        </label>
                      </li>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="drawer__div__content-box queue">
          <span className="drawer__div__content-box__label">Canais:</span>
          <div
            className={
              isViewChannels
                ? "select card--no-mg active"
                : "select card--no-mg"
            }
          >
            <button
              className="select__btn"
              type="button"
              id="mult-filter-inside"
              onClick={() => {
                setIsViewChannels(!isViewChannels);
                setIsViewStatus(false);
                setIsViewSubservices(false);
              }}
            >
              Selecione...
              <i className="select__icon material-icons">
                keyboard_arrow_right
              </i>
            </button>
            <div className="options options--advanced">
              <div className="options--advanced__filter-box">
                <div className="options--advanced__filter-box__content">
                  <div className="checkbox checkbox__list">
                    <div className="checkbox__list__title">
                      Canais
                      <div className="checkbox-all">
                        <li className="checkbox__item-all">
                          <input
                            disabled={isToBlockEdition}
                            className="checkbox__list__input"
                            id={"checkbox-media-all"}
                            name={"checkbox-media-all"}
                            type="checkbox"
                            checked={
                              filterMediaStorage.length === midias.length
                            }
                            onChange={(event) => handleCheckAll(event, "media")}
                          />
                          <label
                            htmlFor={"checkbox-media-all"}
                            style={{
                              cursor: isToBlockEdition
                                ? "not-allowed"
                                : "pointer",
                            }}
                          >
                            {/* {filtermediastorage.length === midias.length
                                ? "Desmarcar todos"
                                : "Marcar todos"} */}
                            {textMediaCheck}
                          </label>
                        </li>
                      </div>
                    </div>
                    {midias.map((midia) => (
                      <li className="checkbox__item" key={midia.id}>
                        <input
                          disabled={isToBlockEdition}
                          className="checkbox__list__input"
                          id={"checkbox-media-" + midia.id}
                          name={"checkbox-media-" + midia.id}
                          type="checkbox"
                          defaultChecked={
                            typemedia.findIndex(function (val) {
                              return val === midia.id;
                            }) !== -1
                              ? true
                              : false
                          }
                          onChange={(event) => getFilterMedia(event, midia.id)}
                        />
                        <label
                          htmlFor={"checkbox-media-" + midia.id}
                          style={{
                            cursor: isToBlockEdition
                              ? "not-allowed"
                              : "pointer",
                          }}
                        >
                          {midia.describer}
                        </label>
                      </li>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="drawer__div__content-box queue">
          <span className="drawer__div__content-box__label">Subserviços:</span>
          <div
            className={
              isViewSubservices
                ? "select card--no-mg active"
                : "select card--no-mg"
            }
          >
            <button
              className="select__btn"
              type="button"
              id="mult-filter-inside"
              onClick={() => {
                setIsViewSubservices(!isViewSubservices);
                setIsViewChannels(false);
                setIsViewStatus(false);
              }}
            >
              Selecione...
              <i className="select__icon material-icons">
                keyboard_arrow_right
              </i>
            </button>
            <div className="options options--advanced">
              <div className="options--advanced__search-box">
                <div className="full-search queue">
                  <input
                    type="text"
                    name="client-search"
                    id="client-search"
                    placeholder="Busca..."
                    onChange={(event) =>
                      setTextSearchSubservice(event.target.value)
                    }
                  />
                  <button type="submit" className="full-search__btn">
                    <i className="material-icons">search</i>
                  </button>
                </div>
              </div>
              <div className="options--advanced__filter-box">
                <div className="options--advanced__filter-box__content">
                  <div className="checkbox checkbox__list">
                    <div className="checkbox__list__title">
                      Subserviços
                      <div className="checkbox-all">
                        <li className="checkbox__item-all">
                          <input
                            disabled={isToBlockEdition}
                            className="checkbox__list__input"
                            id={"checkbox-subservice-all"}
                            name={"checkbox-subservice-all"}
                            type="checkbox"
                            checked={
                              filterSubserviceStorage.length ===
                              subservicesList.length
                            }
                            onChange={(event) =>
                              handleCheckAll(event, "subservice")
                            }
                          />
                          <label
                            htmlFor={"checkbox-subservice-all"}
                            style={{
                              cursor: isToBlockEdition
                                ? "not-allowed"
                                : "pointer",
                            }}
                          >
                            {/* {filterSubserviceStorage.length ===
                              subservicesList.length
                                ? "Desmarcar todos"
                                : "Marcar todos"} */}
                            {textSubserviceCheck}
                          </label>
                        </li>
                      </div>
                    </div>
                    {subservicesList.map((subservice) => (
                      <li className="checkbox__item" key={subservice.id}>
                        <input
                          disabled={isToBlockEdition}
                          className="checkbox__list__input"
                          id={"checkbox-subservice-" + subservice.id}
                          name={"checkbox-subservice-" + subservice.id}
                          type="checkbox"
                          defaultChecked={
                            typesubservice.findIndex(function (val) {
                              return val === subservice.id;
                            }) !== -1
                              ? true
                              : false
                          }
                          onChange={(event) =>
                            getFilterSubservice(event, subservice.id)
                          }
                        />
                        <label
                          htmlFor={"checkbox-subservice-" + subservice.id}
                          style={{
                            cursor: isToBlockEdition
                              ? "not-allowed"
                              : "pointer",
                          }}
                        >
                          <span title={subservice.title}>
                            {subservice.title}
                          </span>
                        </label>
                      </li>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    );
    // if (tabNextCallInfo.isActive) {
    //   return (
    //     <Drawer
    //       className="queue"
    //       filterApply={true}
    //       isOpen={openDrawer}
    //       setCloseDrawer={setVisibleDrawer}
    //       // bind={this}
    //       filtersActive={typequeue}
    //       cleanFilters={(e) => {
    //         clearAllFields();
    //       }}
    //       applyAllFields={applyAllFields}
    //       title="Filtros de Fila"
    //       newVersion={true}
    //     >
    //       <div className="drawer__queue-date">
    //         <FieldContainer
    //           title="Data início"
    //           className="case-client-queue"
    //           htmlFor=""
    //         >
    //           <DatePicker.DateRange
    //             selected={initialDate}
    //             setDate={(event) => {
    //               const newDate = event;
    //               setInitialDate(newDate);
    //             }}
    //             selectRangeType="start"
    //             endDate={finalDate}
    //             maxDate={finalDate}
    //             dateFormat={"dd/MM/yyyy"}
    //             showYearPicker={false}
    //           />
    //         </FieldContainer>

    //         <FieldContainer
    //           title="Data fim"
    //           className="case-client-queue"
    //           htmlFor=""
    //         >
    //           <DatePicker.DateRange
    //             selected={finalDate}
    //             setDate={(event) => {
    //               const newDate = event;
    //               setFinalDate(newDate);
    //             }}
    //             selectRangeType="end"
    //             startDate={initialDate}
    //             minDate={initialDate}
    //             dateFormat="dd/MM/yyyy"
    //             isClearable={false}
    //             showYearPicker={false}
    //           />
    //         </FieldContainer>
    //       </div>
    //       <div className="drawer__div__content-box queue">
    //         <span className="drawer__div__content-box__label">
    //           Status da Fila:
    //         </span>
    //         <div
    //           className={
    //             isViewStatus
    //               ? "select card--no-mg active"
    //               : "select card--no-mg"
    //           }
    //         >
    //           <button
    //             className="select__btn"
    //             type="button"
    //             id="mult-filter-inside"
    //             onClick={() => {
    //               setIsViewStatus(!isViewStatus);
    //               setIsViewChannels(false);
    //               setIsViewSubservices(false);
    //             }}
    //           >
    //             Selecione...
    //             <i className="select__icon material-icons">
    //               keyboard_arrow_right
    //             </i>
    //           </button>
    //           <div className="options options--advanced">
    //             <div className="options--advanced__filter-box">
    //               <div className="options--advanced__filter-box__content">
    //                 <div className="checkbox checkbox__list">
    //                   <div className="checkbox__list__title">
    //                     Status
    //                     <div className="checkbox-all">
    //                       <li className="checkbox__item-all">
    //                         <input
    //                           className="checkbox__list__input"
    //                           id={"checkbox-status-all"}
    //                           name={"checkbox-status-all"}
    //                           type="checkbox"
    //                           defaultChecked={
    //                             filterStatusStorage.length ===
    //                             statusQueue.length
    //                           }
    //                           onChange={(event) =>
    //                             handleCheckAll(event, "status")
    //                           }
    //                         />
    //                         <label htmlFor={"checkbox-status-all"}>
    //                           {/* {filterstatusstorage.length === statusQueue.length
    //                             ? "Desmarcar todos"
    //                             : "Marcar todos"} */}
    //                           {textStatusCheck}
    //                         </label>
    //                       </li>
    //                     </div>
    //                   </div>
    //                   {statusQueue.map((status) => (
    //                     <li className="checkbox__item" key={status.id}>
    //                       <input
    //                         className="checkbox__list__input"
    //                         id={"checkbox-status-" + status.id}
    //                         name={"checkbox-status-" + status.id}
    //                         type="checkbox"
    //                         defaultChecked={
    //                           typestatus.findIndex(function (val) {
    //                             return parseInt(val) === parseInt(status.id);
    //                           }) !== -1
    //                           // ? true
    //                           // : false
    //                         }
    //                         onChange={(event) =>
    //                           getFilterStatus(event, status.id)
    //                         }
    //                       />
    //                       <label htmlFor={"checkbox-status-" + status.id}>
    //                         {status.title}
    //                       </label>
    //                     </li>
    //                   ))}
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       <div className="drawer__div__content-box queue">
    //         <span className="drawer__div__content-box__label">Canais:</span>
    //         <div
    //           className={
    //             isViewChannels
    //               ? "select card--no-mg active"
    //               : "select card--no-mg"
    //           }
    //         >
    //           <button
    //             className="select__btn"
    //             type="button"
    //             id="mult-filter-inside"
    //             onClick={() => {
    //               setIsViewChannels(!isViewChannels);
    //               setIsViewStatus(false);
    //               setIsViewSubservices(false);
    //             }}
    //           >
    //             Selecione...
    //             <i className="select__icon material-icons">
    //               keyboard_arrow_right
    //             </i>
    //           </button>
    //           <div className="options options--advanced">
    //             <div className="options--advanced__filter-box">
    //               <div className="options--advanced__filter-box__content">
    //                 <div className="checkbox checkbox__list">
    //                   <div className="checkbox__list__title">
    //                     Canais
    //                     <div className="checkbox-all">
    //                       <li className="checkbox__item-all">
    //                         <input
    //                           className="checkbox__list__input"
    //                           id={"checkbox-media-all"}
    //                           name={"checkbox-media-all"}
    //                           type="checkbox"
    //                           checked={
    //                             filterMediaStorage.length === midias.length
    //                           }
    //                           onChange={(event) =>
    //                             handleCheckAll(event, "media")
    //                           }
    //                         />
    //                         <label htmlFor={"checkbox-media-all"}>
    //                           {/* {filtermediastorage.length === midias.length
    //                             ? "Desmarcar todos"
    //                             : "Marcar todos"} */}
    //                           {textMediaCheck}
    //                         </label>
    //                       </li>
    //                     </div>
    //                   </div>
    //                   {midias.map((midia) => (
    //                     <li className="checkbox__item" key={midia.id}>
    //                       <input
    //                         className="checkbox__list__input"
    //                         id={"checkbox-media-" + midia.id}
    //                         name={"checkbox-media-" + midia.id}
    //                         type="checkbox"
    //                         defaultChecked={
    //                           typemedia.findIndex(function (val) {
    //                             return val === midia.id;
    //                           }) !== -1
    //                             ? true
    //                             : false
    //                         }
    //                         onChange={(event) =>
    //                           getFilterMedia(event, midia.id)
    //                         }
    //                       />
    //                       <label htmlFor={"checkbox-media-" + midia.id}>
    //                         {midia.describer}
    //                       </label>
    //                     </li>
    //                   ))}
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       <div className="drawer__div__content-box queue">
    //         <span className="drawer__div__content-box__label">
    //           Subserviços:
    //         </span>
    //         <div
    //           className={
    //             isViewSubservices
    //               ? "select card--no-mg active"
    //               : "select card--no-mg"
    //           }
    //         >
    //           <button
    //             className="select__btn"
    //             type="button"
    //             id="mult-filter-inside"
    //             onClick={() => {
    //               setIsViewSubservices(!isViewSubservices);
    //               setIsViewChannels(false);
    //               setIsViewStatus(false);
    //             }}
    //           >
    //             Selecione...
    //             <i className="select__icon material-icons">
    //               keyboard_arrow_right
    //             </i>
    //           </button>
    //           <div className="options options--advanced">
    //             <div className="options--advanced__search-box">
    //               <div className="full-search queue">
    //                 <input
    //                   type="text"
    //                   name="client-search"
    //                   id="client-search"
    //                   placeholder="Busca..."
    //                   onChange={(event) =>
    //                     setTextSearchSubservice(event.target.value)
    //                   }
    //                 />
    //                 <button type="submit" className="full-search__btn">
    //                   <i className="material-icons">search</i>
    //                 </button>
    //               </div>
    //             </div>
    //             <div className="options--advanced__filter-box">
    //               <div className="options--advanced__filter-box__content">
    //                 <div className="checkbox checkbox__list">
    //                   <div className="checkbox__list__title">
    //                     Subserviços
    //                     <div className="checkbox-all">
    //                       <li className="checkbox__item-all">
    //                         <input
    //                           className="checkbox__list__input"
    //                           id={"checkbox-subservice-all"}
    //                           name={"checkbox-subservice-all"}
    //                           type="checkbox"
    //                           checked={
    //                             filterSubserviceStorage.length ===
    //                             subservicesList.length
    //                           }
    //                           onChange={(event) =>
    //                             handleCheckAll(event, "subservice")
    //                           }
    //                         />
    //                         <label htmlFor={"checkbox-subservice-all"}>
    //                           {/* {filterSubserviceStorage.length ===
    //                           subservicesList.length
    //                             ? "Desmarcar todos"
    //                             : "Marcar todos"} */}
    //                           {textSubserviceCheck}
    //                         </label>
    //                       </li>
    //                     </div>
    //                   </div>
    //                   {subservicesList.map((subservice) => (
    //                     <li className="checkbox__item" key={subservice.id}>
    //                       <input
    //                         className="checkbox__list__input"
    //                         id={"checkbox-subservice-" + subservice.id}
    //                         name={"checkbox-subservice-" + subservice.id}
    //                         type="checkbox"
    //                         defaultChecked={
    //                           typesubservice.findIndex(function (val) {
    //                             return val === subservice.id;
    //                           }) !== -1
    //                             ? true
    //                             : false
    //                         }
    //                         onChange={(event) =>
    //                           getFilterSubservice(event, subservice.id)
    //                         }
    //                       />
    //                       <label
    //                         htmlFor={"checkbox-subservice-" + subservice.id}
    //                       >
    //                         <span title={subservice.title}>
    //                           {subservice.title}
    //                         </span>
    //                       </label>
    //                     </li>
    //                   ))}
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </Drawer>
    //   );
    // } else {
    //   return null;
    //   // return (
    //   //   <Drawer
    //   //     className="queue"
    //   //     filterApply={true}
    //   //     isOpen={openDrawer}
    //   //     setCloseDrawer={setVisibleDrawer}
    //   //     // bind={this}
    //   //     filtersActive={typequeue}
    //   //     cleanFilters={(e) => {
    //   //       clearclearAllFieldsQuarentine();
    //   //     }}
    //   //     applyAllFields={applyAllFields}
    //   //     title="Filtros do Standby"
    //   //     newVersion={true}
    //   //   >
    //   //     <div className="drawer__queue-date">
    //   //       <FieldContainer
    //   //         title="Data início"
    //   //         className="case-client-queue"
    //   //         htmlFor=""
    //   //       >
    //   //         <DatePicker.DateRange
    //   //           selected={initialDateQuarentine}
    //   //           setDate={(event) => {
    //   //             const newDate = event;
    //   //             dispatch(editInitialDateFilterQuarentine(newDate));
    //   //             setInitialDateQuarentine(newDate);
    //   //           }}
    //   //           selectRangeType="start"
    //   //           endDate={finalDateQuarentine}
    //   //           maxDate={finalDateQuarentine}
    //   //           dateFormat={"dd/MM/yyyy"}
    //   //           showYearPicker={false}
    //   //         />
    //   //       </FieldContainer>

    //   //       <FieldContainer
    //   //         title="Data fim"
    //   //         className="case-client-queue"
    //   //         htmlFor=""
    //   //       >
    //   //         <DatePicker.DateRange
    //   //           selected={finalDateQuarentine}
    //   //           setDate={(event) => {
    //   //             const newDate = event;
    //   //             dispatch(editFinalDateFilterQuarentine(newDate));
    //   //             setFinalDateQuarentine(newDate);
    //   //           }}
    //   //           selectRangeType="end"
    //   //           startDate={initialDateQuarentine}
    //   //           minDate={initialDateQuarentine}
    //   //           dateFormat="dd/MM/yyyy"
    //   //           isClearable={false}
    //   //           showYearPicker={false}
    //   //         />
    //   //       </FieldContainer>
    //   //     </div>
    //   //     <div className="drawer__div__content-box queue">
    //   //       <span className="drawer__div__content-box__label">Canais:</span>
    //   //       <div
    //   //         className={
    //   //           isViewChannels
    //   //             ? "select card--no-mg active"
    //   //             : "select card--no-mg"
    //   //         }
    //   //       >
    //   //         <button
    //   //           className="select__btn"
    //   //           type="button"
    //   //           id="mult-filter-inside"
    //   //           onClick={() => {
    //   //             setIsViewChannels(!isViewChannels);
    //   //             setIsViewStatus(false);
    //   //             setIsViewSubservices(false);
    //   //           }}
    //   //         >
    //   //           Selecione...
    //   //           <i className="select__icon material-icons">
    //   //             keyboard_arrow_right
    //   //           </i>
    //   //         </button>
    //   //         <div className="options options--advanced">
    //   //           <div className="options--advanced__filter-box">
    //   //             <div className="options--advanced__filter-box__content">
    //   //               <div className="checkbox checkbox__list">
    //   //                 <div className="checkbox__list__title">
    //   //                   Canais
    //   //                   <div className="checkbox-all">
    //   //                     <li className="checkbox__item-all">
    //   //                       <input
    //   //                         className="checkbox__list__input"
    //   //                         id={"checkbox-media-all-quarentine"}
    //   //                         name={"checkbox-media-all-quarentine"}
    //   //                         type="checkbox"
    //   //                         checked={
    //   //                           filtermediastorageQuarentine.length ===
    //   //                           midias.length
    //   //                         }
    //   //                         onChange={(event) =>
    //   //                           handleCheckAllQuarentine(event, "media")
    //   //                         }
    //   //                       />
    //   //                       <label htmlFor={"checkbox-media-all-quarentine"}>
    //   //                         {filtermediastorageQuarentine.length ===
    //   //                         midias.length
    //   //                           ? "Desmarcar todos"
    //   //                           : "Marcar todos"}
    //   //                       </label>
    //   //                     </li>
    //   //                   </div>
    //   //                 </div>
    //   //                 {midias.map((midia) => (
    //   //                   <li className="checkbox__item" key={midia.id}>
    //   //                     <input
    //   //                       className="checkbox__list__input"
    //   //                       id={"checkbox-media-quarentine-" + midia.id}
    //   //                       name={"checkbox-media-quarentine-" + midia.id}
    //   //                       type="checkbox"
    //   //                       defaultChecked={
    //   //                         filtermediastorageQuarentine.findIndex(function (
    //   //                           val
    //   //                         ) {
    //   //                           return val === midia.id;
    //   //                         }) !== -1
    //   //                           ? true
    //   //                           : false
    //   //                       }
    //   //                       onChange={(event) =>
    //   //                         getFilterMediaQuarentine(event, midia.id)
    //   //                       }
    //   //                     />
    //   //                     <label
    //   //                       htmlFor={"checkbox-media-quarentine-" + midia.id}
    //   //                     >
    //   //                       {midia.describer}
    //   //                     </label>
    //   //                   </li>
    //   //                 ))}
    //   //               </div>
    //   //             </div>
    //   //           </div>
    //   //         </div>
    //   //       </div>
    //   //     </div>
    //   //   </Drawer>
    //   // );
    // }
  }

  //USEEFFECT
  useEffect(() => {
    const checkStatus = (statusIds) => {
      try {
        const hasCallBack = statusIds.includes("0");
        document.getElementById("checkbox-status-0").checked = hasCallBack;
        const hasFila = statusIds.includes("1");
        document.getElementById("checkbox-status-1").checked = hasFila;
        const hasTratamento = statusIds.includes("2");
        document.getElementById("checkbox-status-2").checked = hasTratamento;
        const hasRetornando = statusIds.includes("5");
        document.getElementById("checkbox-status-5").checked = hasRetornando;
      } catch (error) {
        console.log("checkStatus Error: ", error);
      }
    };
    if (Boolean(filtrosDeFila) && Boolean(filtrosDeFila.storageSubservice)) {
      setFilterSubserviceStorage(filtrosDeFila.storageSubservice);
      setTypeSubservice(filtrosDeFila.storageSubservice);
    }
    if (Boolean(filtrosDeFila) && Boolean(filtrosDeFila.storageMedia)) {
      setFilterMediaStorage(filtrosDeFila.storageMedia);
      setTypeMedia(filtrosDeFila.storageMedia);
    }
    if (Boolean(filtrosDeFila) && Boolean(filtrosDeFila.storageStatus)) {
      setFilterStatusStorage(filtrosDeFila.storageStatus);
      setTypeStatus(filtrosDeFila.storageStatus);
      dispatch(arrayChange(filtrosDeFila.storageStatus));
      checkStatus(filtrosDeFila.storageStatus);
    }
  }, [filtrosDeFila]);
  useEffect(() => {
    updateFilteredList();
  }, []);

  useEffect(() => {
    updateFilteredList();
  }, [
    listQuarentineQueue,
    filterQuarentineQueue,
    filtermediastorageQuarentine,
    initialDateQuarentine,
    finalDateQuarentine,
  ]);

  useEffect(() => {
    let nomesDasFilas = [];
    if (ListQueuePermission.queuepermission) {
      const idsDasFilas = new Set();

      ListQueuePermission.queuepermission.forEach((queue) => {
        const nomeDaFila = getInfoQueue2(queue);
        if (nomeDaFila && !idsDasFilas.has(nomeDaFila.id)) {
          idsDasFilas.add(nomeDaFila.id);
          nomesDasFilas.push(nomeDaFila);
        }
      });
    }

    saveFiltersOptions(false, false, nomesDasFilas);

    const listSubservice = nomesDasFilas || [];
    nomesDasFilas = _.filter(listSubservice, (subservice) => {
      let arraySubservice = [subservice.title];
      return !_.isEmpty(textSearchSubservice)
        ? arraySubservice
            .toString()
            .toLowerCase()
            .indexOf(textSearchSubservice.toString().toLowerCase()) > -1
        : true;
    });

    setSubservicesList(nomesDasFilas);
  }, [ListQueuePermission, textSearchSubservice]);

  useEffect(() => {
    if (Object.keys(DisplayNextAtd).length !== 0) {
      if (
        DisplayNextAtd.displaynextatd === true ||
        (DisplayNextAtd.displaynextatd === "ocultar" &&
          InfoDisplay.infodisplay === "Equipes") ||
        exhibDrawer
      ) {
        setVisible(" active");
      } else if (DisplayNextAtd.displaynextatd === false) {
        setVisible(" w-40");
      } else if (
        DisplayNextAtd.displaynextatd === "ocultar" &&
        InfoDisplay.infodisplay === "Clientes"
      ) {
        setVisible(" w-40");
      } else {
        setVisible(" w-40");
      }
    }
  }, [DisplayNextAtd, InfoDisplay, exhibDrawer]);

  useEffect(() => {
    if (!exhibDrawer && openDrawer) {
      setVisibleDrawer();
    }
  }, [exhibDrawer]);

  useEffect(() => {
    if (listCallQueue.length !== 0) {
      let newCallQueue = listCallQueue;

      if (Filters.length !== 0) {
        // if (Filters.array_fila.length !== 0) {
        if (Filters.array_fila !== "") {
          let filtroArr = Filters.array_fila;
          newCallQueue = newCallQueue.filter((queue) =>
            filtroArr.includes(queue.status),
          );
        }
      }
      if (typemedia !== "") {
        newCallQueue = newCallQueue.filter((queue) =>
          typemedia.includes(queue.mediaid),
        );
      }
      if (typesubservice.length !== 0) {
        newCallQueue = newCallQueue.filter((queue) =>
          typesubservice.includes(queue.serviceinid),
        );
      } else if (typesubservice.length === 0) {
        newCallQueue = [];
      }

      const list = newCallQueue || [];
      newCallQueue = _.filter(list, (queue) => {
        let arrayQueue = [
          queue.caller,
          queue.called,
          queue.to_char,
          queue.recv_count,
          queue.contactname,
          queue.username,
        ];
        return !_.isEmpty(filterQueue)
          ? arrayQueue
              .toString()
              .toLowerCase()
              .indexOf(filterQueue.toString().toLowerCase()) > -1
          : true;
      });

      newCallQueue = newCallQueue.reverse(function (obj1, obj2) {
        return obj1.to_char > obj2.to_char
          ? 1
          : obj2.to_char > obj1.to_char
            ? -1
            : 0;
      });

      if (InfoUsers.user_midias) {
        newCallQueue = newCallQueue.filter((queue) =>
          InfoUsers.user_midias.includes(queue.mediaid),
        );
      }

      if (parseInt(InfoUsers.tmcallback) > 0) {
        if (StatusAgent.status === "Pausado") {
          clearTimeout(statusIntervalCBack);
          autoAsnwerCallbackServiceSingleton.resetList();
          checkCallBack = false;
        } else if (StatusAgent.status === "Livre" && !isRegistrandoCip) {
          if (!checkCallBack) {
            // Ordena primeiro por callback_count e, em caso de empate, pela data/hora mais distante da atual
            newCallQueue = newCallQueue.sort((a, b) => {
              // Ordena por callback_count em ordem crescente
              const callbackCountDiff =
                parseInt(a.callback_count) - parseInt(b.callback_count);

              if (callbackCountDiff !== 0) {
                return callbackCountDiff;
              }

              // Em caso de empate, ordena pela data/hora mais distante da atual (to_char)
              const dateA = new Date(a.to_char);
              const dateB = new Date(b.to_char);

              // Ordena em ordem decrescente de data
              return dateB - dateA;
            });

            // Após ordenar, você pode continuar com a lógica de filtro e mapeamento
            newCallQueue = newCallQueue
              .filter((queue) => {
                const callbackMidias = InfoUsers.callback_midias
                  ? InfoUsers.callback_midias.split(",").map((m) => m.trim())
                  : [];

                return (
                  callbackMidias.length === 0 ||
                  callbackMidias.includes(queue.mediaid.toString())
                );
              })
              .map((queue) => {
                // if (
                //   parseInt(queue.callback_count) <
                //     parseInt(InfoUsers.qtdecallback) &&
                //   parseInt(queue.status) === 0 &&
                //   checkCallBack === false
                // ) {
                //   clearInterval(statusIntervalCBack);
                //   checkCallBack = true;
                //   const isThisCallAlreadyInTheList =
                //     autoAsnwerCallbackServiceSingleton.isThisCallAlreadyInTheList(
                //       queue.queueid,
                //     );
                //   if (!isThisCallAlreadyInTheList) {
                //     checkCallBackAuto(
                //       queue.queueid,
                //       InfoUsers.tmcallback,
                //       InfoUsers.qtdecallback,
                //       queue,
                //       queue,
                //     );
                //   }
                // }

                return queue;
              });

            const treatListForCallback = () => {
              try {
                let queueForCallBack = cloneDeep(listCallQueue) || [];
                queueForCallBack = queueForCallBack.sort((a, b) => {
                  // Ordena por callback_count em ordem crescente
                  const callbackCountDiff =
                    parseInt(a.callback_count) - parseInt(b.callback_count);

                  if (callbackCountDiff !== 0) {
                    return callbackCountDiff;
                  }

                  // Em caso de empate, ordena pela data/hora mais distante da atual (to_char)
                  const dateA = new Date(a.to_char);
                  const dateB = new Date(b.to_char);

                  // Ordena em ordem decrescente de data
                  return dateB - dateA;
                });

                queueForCallBack
                  .filter((queue) => {
                    const callbackMidias = InfoUsers.callback_midias
                      ? InfoUsers.callback_midias
                          .split(",")
                          .map((m) => m.trim())
                      : [];

                    return (
                      callbackMidias.length === 0 ||
                      callbackMidias.includes(queue.mediaid.toString())
                    );
                  })
                  .forEach((queue) => {
                    if (
                      parseInt(queue.callback_count) <
                        parseInt(InfoUsers.qtdecallback) &&
                      parseInt(queue.status) === 0 &&
                      checkCallBack === false
                    ) {
                      clearTimeout(statusIntervalCBack);
                      autoAsnwerCallbackServiceSingleton.resetList();
                      checkCallBack = true;
                      const isThisCallAlreadyInTheList =
                        autoAsnwerCallbackServiceSingleton.isThisCallAlreadyInTheList(
                          queue.queueid,
                        );
                      if (!isThisCallAlreadyInTheList) {
                        checkCallBackAuto(
                          queue.queueid,
                          InfoUsers.tmcallback,
                          InfoUsers.qtdecallback,
                          queue,
                          queue,
                        );
                      }
                    }

                    return queue;
                  });
              } catch (error) {}
            };

            treatListForCallback();
          }
        } else if (
          StatusAgent.status === "Atendimento" ||
          StatusAgent.status === "Ligação" ||
          StatusAgent.status === "Discando" ||
          StatusAgent.status === "Chamando" ||
          StatusAgent.status === "Aftercallwork" ||
          isRegistrandoCip ||
          StatusAgent.status !== "Livre"
        ) {
          clearTimeout(statusIntervalCBack);
          autoAsnwerCallbackServiceSingleton.resetList();
          checkCallBack = false;
        }
      }
      newCallQueue = newCallQueue.filter((cliente) => {
        const date1 = Moment(initialDateAfter).format("YYYYMMDD");
        const date2 = Moment(finalDateAfter).format("YYYYMMDD");

        // se cliente não existe ou não tem to_char -> descarta
        if (!cliente || !cliente.to_char) return false;

        const date3 = Moment(cliente.to_char, "DD/MM/YYYY HH:mm:ss", true);
        if (!date3.isValid()) return false; // descarta se não for data válida

        const dateFormatted = date3.format("YYYYMMDD");

        return dateFormatted >= date1 && dateFormatted <= date2;
      });

      // newCallQueue = newCallQueue.filter((cliente) => {
      //   const date1 = Moment(initialDateAfter).format("YYYYMMDD");
      //   const date2 = Moment(finalDateAfter).format("YYYYMMDD");

      //   if (!cliente.to_char) return false; // se não tem data, descarta

      //   const date3 = Moment(cliente.to_char, "DD/MM/YYYY HH:mm:ss", true);
      //   if (!date3.isValid()) return false; // descarta se não for data válida

      //   const dateFormatted = date3.format("YYYYMMDD");

      //   return dateFormatted >= date1 && dateFormatted <= date2;
      // });
      setQtdOfClientsInTheQueue(newCallQueue.length);

      newCallQueue = newCallQueue.slice(0, scrollEnd);

      setCallQueue(newCallQueue);
    } else {
      setCallQueue([]);
      setQtdOfClientsInTheQueue(0);
    }
  }, [
    listCallQueue,
    Filters,
    typemedia,
    typesubservice,
    filterQueue,
    InfoUsers,
    StatusAgent,
    scrollEnd,
    isRegistrandoCip,
  ]);

  useEffect(() => {
    if (Filters.length !== 0) {
      // if (Filters.array_fila.length !== 0) {
      if (Filters.array_fila !== "") {
        let filtroArr = Filters.array_fila;
        saveFiltersOptions(filtroArr, false, false);
      }
    }
  }, [Filters]);

  useEffect(() => {
    if (modalOpen) {
      const findQueue = callqueue.find(
        (queue) => parseInt(queue.queueid) === parseInt(queueModalOpen),
      );
      if (!findQueue) {
        MicroModal.close(modalOpen);
        setModalOpen("");
        setQueueModalOpen("");
      }
    }
  }, [modalOpen]);

  useEffect(() => {
    if (CriticidadesAnotacoes.length !== 0) {
      let newDescAnotacoes = CriticidadesAnotacoes.criticalitys;
      if (idCrit2 === 0) {
        setIconeCriticidade(newDescAnotacoes[0].class_criticality);
        setSelecCritic(newDescAnotacoes[0].description);
        setIdCrit2(newDescAnotacoes[0].id);
      }
      setDescAnotacoes(newDescAnotacoes);
    }
  }, [CriticidadesAnotacoes, idCrit2]);

  useEffect(() => {
    if (DetailsAnotations.length !== 0) {
      setDetailsAnotations(DetailsAnotations.detailsanotations);
      setTotalAnotations(DetailsAnotations.detailsanotations.length);
    } else {
      setDetailsAnotations([]);
      setTotalAnotations(0);
    }
  }, [DetailsAnotations]);

  useEffect(() => {
    if (DetailsMarkstar.length !== 0) {
      setDetailsMarkstar(DetailsMarkstar.detailsmarkstars);
      setTotalMarkstar(DetailsMarkstar.detailsmarkstars.length);
    } else {
      setDetailsMarkstar([]);
      setTotalMarkstar(0);
    }
  }, [DetailsMarkstar]);

  useEffect(() => {
    if (DetailsFileShared.length !== 0) {
      setDetailsFileShared(DetailsFileShared.detailsfileshared);
      setTotalFiles(DetailsFileShared.detailsfileshared.length);
    } else {
      setDetailsFileShared([]);
      setTotalFiles(0);
    }
  }, [DetailsFileShared]);

  useEffect(() => {
    if (History.length) {
      let newHistory = History;
      let testarultimo = 0;
      var total = newHistory[0];
      setHistory(newHistory);
      setTotalHistory(total.interacoes);
    } else {
      setHistory([]);
    }
  }, [History]);

  useEffect(() => {
    if (IPCurrent.length !== 0) {
      setMidias(Boolean(IPCurrent.midias) ? IPCurrent.midias : []);
      saveFiltersOptions(false, IPCurrent, false);
    }
  }, [IPCurrent]);

  useEffect(() => {
    if (AtdSimult.length > 0) {
      let totalMsgsChats = 0;
      const filterAtd = AtdSimult.filter(
        (atd) => atd.idatendimento !== ContactId.idatendimento,
      );
      const sumTotal = AtdSimult.map(
        (atd) => (totalMsgsChats = totalMsgsChats + parseInt(atd.qtdmessage)),
      );
      setQtdOfChatsInTheQueue(AtdSimult.length);
      setMsgsTotalChats(totalMsgsChats);
    } else {
      setMsgsTotalChats(0);
    }
  }, [AtdSimult]);

  useEffect(() => {
    if (!InfoUsers.standby_permission) {
      const verifyTab = localStorage.getItem("tabChoice");
      if (verifyTab === "waitingInfo") {
        localStorage.setItem("tabChoice", "nextCall");
        dispatch(changeNextCallQueueTab(true));
        dispatch(changeWaitingCallQueueTab(false));
        dispatch(changeChatCallQueueTab(false));
        setTabWaitingInfo({ ...tabWaitingInfo, isActive: false });
        setTabNextCallInfo({ ...tabNextCallInfo, isActive: true });
        setTabChatsInfo({ ...tabChatsInfo, isActive: false });
      }
    }
  }, [InfoUsers]);

  useEffect(() => {
    dispatch(
      sendQueueAndStandby(
        qtdOfClientsInTheQueue,
        qtdOfClientsInQuarentineZone,
        qtdOfUnreadedMessagesInQuarentineZone,
      ),
    );
  }, [
    qtdOfClientsInTheQueue,
    qtdOfClientsInQuarentineZone,
    qtdOfUnreadedMessagesInQuarentineZone,
  ]);

  useEffect(() => {
    if (typeScreen === "nextCall") {
      dispatch(changeNextCallQueueTab(true));
      dispatch(changeWaitingCallQueueTab(false));
      dispatch(changeChatCallQueueTab(false));
      setTabNextCallInfo({ ...tabNextCallInfo, isActive: true });
      setTabWaitingInfo({ ...tabWaitingInfo, isActive: false });
      setTabChatsInfo({ ...tabChatsInfo, isActive: false });
    } else if (typeScreen === "waiting") {
      dispatch(changeNextCallQueueTab(false));
      dispatch(changeWaitingCallQueueTab(true));
      dispatch(changeChatCallQueueTab(false));
      setTabNextCallInfo({ ...tabNextCallInfo, isActive: false });
      setTabWaitingInfo({ ...tabWaitingInfo, isActive: true });
      setTabChatsInfo({ ...tabChatsInfo, isActive: false });
    }
  }, [typeScreen]);

  return (
    <div
      id="column1"
      className={
        "chat-page queue-new " +
        visible +
        (InfoDisplay.infodisplay === "Clientes"
          ? " new-queueinew-side-menu new-queueinew-side-menu-v2"
          : " new-queueinew-side-menu new-queueinew-side-menu-v2 no-margin-and-no-round-border")
      }
    >
      <div
        className={
          "block full-height w-100 no-margin-bottom" +
          (exhibDrawer ? " drawer-exhib" : "")
        }
        id="proximos-atendimentos"
      >
        <div
          className={
            "column-model__header" +
            (InfoDisplay.infodisplay === "Clientes"
              ? " new-queueinew-side-menu new-queueinew-side-menu-v2"
              : " new-queueinew-side-menu new-queueinew-side-menu-v2 no-margin-and-no-round-border")
          }
        >
          {!exhibDrawer && (
            <div
              className={
                "column-model__header__title" +
                (InfoDisplay.infodisplay === "Clientes"
                  ? " new-queueinew-side-menu new-queueinew-side-menu-v2 client-screen-header"
                  : " new-queueinew-side-menu new-queueinew-side-menu-v2 no-margin-and-no-round-border")
              }
            >
              <button
                type="submit"
                onClick={(event) => ShowVisible(false)}
                className="column-model__header__title__btn tippy-default"
                data-tippy-content="Ocultar"
              >
                <Arrow />
                {/* aq esta */}
              </button>
              <div className="queue-new-v2-menu-tabs">
                <QueueTab
                  tabInfo={tabChatsInfo}
                  qtdClients={AtdSimult.length}
                  qtdMessages={msgsTotalChats}
                  onClick={() => {
                    const isAlreadyActive = tabChatsInfo.isActive;
                    if (isAlreadyActive) return;

                    dispatch(changeNextCallQueueTab(false));
                    dispatch(changeWaitingCallQueueTab(false));
                    dispatch(changeChatCallQueueTab(true));
                    setTabWaitingInfo({ ...tabWaitingInfo, isActive: false });
                    setTabNextCallInfo({ ...tabNextCallInfo, isActive: false });
                    setTabChatsInfo({ ...tabChatsInfo, isActive: true });
                    localStorage.setItem("tabChoice", "chatInfo");
                  }}
                  iconUse={true}
                />
                <QueueTab
                  tabInfo={tabNextCallInfo}
                  qtdClients={qtdOfClientsInTheQueue}
                  onClick={() => {
                    const isAlreadyActive = tabNextCallInfo.isActive;
                    if (isAlreadyActive) return;
                    dispatch(changeNextCallQueueTab(true));
                    dispatch(changeWaitingCallQueueTab(false));
                    dispatch(changeChatCallQueueTab(false));
                    setTabWaitingInfo({ ...tabWaitingInfo, isActive: false });
                    setTabNextCallInfo({ ...tabNextCallInfo, isActive: true });
                    setTabChatsInfo({ ...tabChatsInfo, isActive: false });
                    localStorage.setItem("tabChoice", "nextCall");
                  }}
                  iconUse={true}
                />
                {InfoUsers.standby_permission && (
                  <QueueTab
                    tabInfo={tabWaitingInfo}
                    qtdClients={qtdOfClientsInQuarentineZone}
                    qtdMessages={qtdOfUnreadedMessagesInQuarentineZone}
                    onClick={() => {
                      const isAlreadyActive = tabWaitingInfo.isActive;
                      if (isAlreadyActive) return;
                      dispatch(changeNextCallQueueTab(false));
                      dispatch(changeWaitingCallQueueTab(true));
                      dispatch(changeChatCallQueueTab(false));
                      setTabWaitingInfo({ ...tabWaitingInfo, isActive: true });
                      setTabNextCallInfo({
                        ...tabNextCallInfo,
                        isActive: false,
                      });
                      setTabChatsInfo({ ...tabChatsInfo, isActive: false });
                      localStorage.setItem("tabChoice", "waitingInfo");
                    }}
                    iconUse={true}
                  />
                )}
              </div>
            </div>
          )}

          <div className="full-search">
            <div className="full-search__header">
              <Typography.H4 color={"gray-180"} weight={500}>
                {tabNextCallInfo.isActive
                  ? tabNextCallInfo.title
                  : tabWaitingInfo.isActive
                    ? tabWaitingInfo.title
                    : tabChatsInfo.title}
              </Typography.H4>
              {!tabChatsInfo.isActive && (
                <div className="full-search__header--icons">
                  {!tabWaitingInfo.isActive && (
                    <Tooltippy content={expandInfos.RetractExpand}>
                      <div
                        className="top-bar queue-new-v2-top-bar"
                        onClick={(e) => DisplayDetails(e)}
                      >
                        <a
                          href="{#}"
                          className=""
                          data-action={expandInfos.expandcollapse}
                          id="expand-all-user-info"
                        >
                          <IconMaximize />
                        </a>
                      </div>
                    </Tooltippy>
                  )}
                  {!tabWaitingInfo.isActive && (
                    <FilterIconNew
                      className="filter-icon"
                      onClick={() => setOpenDrawer(true)}
                    />
                  )}
                </div>
              )}
            </div>
            <div className="full-search_container">
              <button type="submit" className="full-search__btn">
                <Search />
              </button>
              <input
                type="text"
                name="client-search"
                id="client-search"
                onChange={(event) => changeQueue(event)}
                placeholder="Pesquisar"
                value={
                  tabWaitingInfo.isActive || tabChatsInfo.isActive
                    ? filterQuarentineQueue
                    : Array.isArray(filterQueue) && filterQueue.length === 0
                      ? ""
                      : filterQueue
                }
              />
              {filterQuarentineQueue ||
              (Array.isArray(filterQueue) && filterQueue.length > 0) ? (
                <CloseCircle
                  color="#757575"
                  onClick={(event) => clearChangeQueue("")}
                  style={{ cursor: "pointer" }}
                />
              ) : (
                ""
              )}
            </div>
          </div>

          {renderItemQueue(
            IPCurrent,
            InfoUsers,
            StatusAgent,
            AtdSimult,
            OutBandService,
            PermissionRouter,
            callpark,
            initialDate,
            finalDate,
          )}
        </div>
      </div>

      {InfoDisplay.infodisplay !== "Clientes" ||
      (InfoDisplay.infodisplay === "Clientes" && !ContactId.telefone) ? (
        <>
          <ModalsDetails.NewAnotationModal />

          <ModalsDetails.NewMessageFavoriteModal />

          <ModalsDetails.NewFileShareModal />

          <ModalsDetails.InteractionsHistoricModal />
        </>
      ) : (
        <></>
      )}

      <DeleteCallModal
        deletecdrid={deletecdrid}
        deletequeueid={deletequeueid}
        mediaid={mediaid}
      />

      <input type="hidden" id="simulation_click" name="simulation_click" />

      {renderDrawer()}

      {!tabChatsInfo.isActive && (
        <TransferClientModal
          infoQueue={{
            cdrid: cdrid,
            scriptid: scriptid,
            mediaid: mediaid,
            queueId: queueid,
          }}
        />
      )}
    </div>
  );
}
